/* Deck input for the product page and the TRC order editor (snippets/buy-buttons.liquid).
 * Moved out of the snippet to keep it under Shopify's 256 KB template limit, unchanged apart from
 * reading the Liquid-rendered values from deckInputConfig.
 * The snippet keeps a small inline script per instance: it captures its own <script> element
 * (document.currentScript) and the Liquid-rendered values, then calls TRCDeckInput.init once
 * the DOM is ready. Instances that become ready before this file has run wait in
 * TRCDeckInputQueue and are initialized here, in order.
 * Cached page HTML can pair an older deckInputConfig with a newer copy of this file, so keep the
 * config keys backward compatible (give a missing key a default) or version them. The same goes for
 * assets/trc-deck-feedback.js, which the snippet loads first: this file loads it if that tag is missing. */
(function () {
  // --- Shared deck wording and list helpers ---
  // assets/trc-deck-feedback.js (window.TRCDeckFeedback) is the theme's copy of the upload
  // Worker's src/deck-feedback.mjs: section headers, cleanDecklistText (the list as the Worker
  // signs it), the live tally and its messages, print option ranges and deck links.
  // tests/deck-feedback.test.mjs pins it to the Worker's SHA-256 values and shared vectors.
  // The snippet loads it before this file; whenFeedback covers a page cached before that tag.
  var F = window.TRCDeckFeedback || null;
  var OWN_SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';
  function cleanDecklistText(value) { return F.cleanDecklistText(value); }
  function variantDeckContents(title) { return F.variantDeckContents(title); }
  function canonicalDeckUrl(value) { return F.canonicalDeckUrl(value); }
  function isSectionHeader(line) { return F.DECKLIST_SECTION_HEADER.test(line); }
  // D-2: an MTGO .dek file (<Deck><Cards Quantity Sideboard Name/></Deck>) as
  // "N Name" lines with a Sideboard section. A plain-text .dek is returned as
  // it is (cleanDecklistText moves its "SB:" lines). null: not a readable deck.
  function convertDekFile(text) {
    var source = String(text || '').replace(/^﻿/, '');
    if (!/^\s*</.test(source)) return source;
    var doc;
    try { doc = new DOMParser().parseFromString(source, 'application/xml'); } catch (_) { return null; }
    if (!doc || doc.getElementsByTagName('parsererror').length) return null;
    var boards = { main: [], side: [] };
    var seen = {};
    Array.prototype.forEach.call(doc.getElementsByTagName('Cards'), function (card) {
      var quantity = Number(card.getAttribute('Quantity'));
      var name = String(card.getAttribute('Name') || '').replace(/\s+/g, ' ').trim();
      if (!name || !Number.isInteger(quantity) || quantity < 1) return;
      var board = /^true$/i.test(String(card.getAttribute('Sideboard') || '').trim()) ? 'side' : 'main';
      var key = board + '\n' + name.toLowerCase();
      if (seen[key]) { seen[key].quantity += quantity; return; }
      seen[key] = { quantity: quantity, name: name };
      boards[board].push(seen[key]);
    });
    function lines(list) { return list.map(function (card) { return card.quantity + ' ' + card.name; }); }
    if (!boards.main.length && !boards.side.length) return null;
    return lines(boards.main).concat(boards.side.length ? ['', 'Sideboard'].concat(lines(boards.side)) : []).join('\n');
  }
  // Cloudflare Turnstile loads only on pages with a deck input (the snippet
  // adds it while the page is parsed). This loads it if that tag never ran,
  // for example markup inserted later. Never twice: a second api.js breaks it.
  var TURNSTILE_API_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  function loadTurnstileApi() {
    try {
      if (window.turnstile || document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/"]')) return;
      var api = document.createElement('script');
      api.src = TURNSTILE_API_URL;
      api.async = true;
      (document.head || document.documentElement).appendChild(api);
    } catch (_) {}
  }
          function initDeckInput(ownerScript, deckInputConfig) {
          var scope = ownerScript && (ownerScript.closest('product-info') || ownerScript.closest('.product-form'));
          if (!scope || !scope.isConnected) return;
          var root = scope.querySelector('.deck-input');
          if (!root || root.dataset.validationInitialized) return;
          if (root.dataset.companionBaseUrl) {
            var baseUrl = new URL(root.dataset.companionBaseUrl, window.location.origin);
            var baseVariant = baseUrl.searchParams.get('variant');
            baseUrl.search = window.location.search;
            if (baseVariant) baseUrl.searchParams.set('variant', baseVariant);
            else baseUrl.searchParams.delete('variant');
            window.location.replace(baseUrl.href);
            return;
          }
          root.dataset.validationInitialized = 'true';
          var lifecycle = new AbortController();
          function byId(id) { return scope.querySelector('[id="' + id + '"]'); }
          // Raw browser errors ("Load failed", "Failed to fetch") become plain copy (trc-compat.js).
          function friendlyErrorText(message) {
            var compat = window.TRCCompat;
            return compat && typeof compat.friendlyErrorMessage === 'function' ? compat.friendlyErrorMessage(message, F.MESSAGES.retryFallback) : message;
          }
          function withRetryHint(message) {
            return F.withRetryHint(friendlyErrorText(message));
          }
          // Safari 14 ignores the signal option, so listeners are also removed by hand on dispose.
          var lifecycleListeners = [];
          function listen(target, type, handler, options) {
            if (lifecycle.signal.aborted) return;
            var listenerOptions = Object.assign({}, typeof options === 'boolean' ? {capture: options} : options, {signal: lifecycle.signal});
            target.addEventListener(type, handler, listenerOptions);
            lifecycleListeners.push([target, type, handler, !!listenerOptions.capture]);
          }
          // Inline confirmation (trc-compat.js): window.confirm is silently blocked
          // in some in-app browsers. Without trc-compat.js, fall back to it.
          function askToConfirm(anchor, message, confirmLabel, destructive, signal) {
            var compat = window.TRCCompat;
            if (!compat || typeof compat.confirm !== 'function') return Promise.resolve(window.confirm(message));
            return compat.confirm({anchor: anchor, message: message, confirmLabel: confirmLabel, destructive: !!destructive, signal: signal || lifecycle.signal});
          }
          // An upload or cart request that stalls (a dropped mobile connection) fails
          // instead of hanging: 30 s plus time for the body at 50 KB/s. The timeout
          // also covers reading the reply. Callers retry it like a network error.
          function timedFetch(url, init, bodyBytes, read) {
            var controller = typeof AbortController === 'function' ? new AbortController() : null;
            var timer = controller ? window.setTimeout(function () { controller.abort(); }, 30000 + Math.ceil(Number(bodyBytes || 0) / 50000) * 1000) : null;
            return fetch(url, controller ? Object.assign({}, init, {signal: controller.signal}) : init).then(read).finally(function () {
              if (timer) window.clearTimeout(timer);
            });
          }
          var textarea  = byId('decklist');
          var urlInput  = byId('decklistUrl');
          var sideboardCheck = byId('deckSideboard');
          var xmlInput  = byId('decklistXml');     // hidden field, holds the R2 URL
          var xmlFile   = byId('decklistXmlFile'); // the file picker
          var xmlFileName = byId('xmlFileName');
          var count     = byId('deckCount');
          var creatorCopyLink = scope.querySelector(deckInputConfig.CREATOR_COPY_LINK_SELECTOR);
          var creatorCopyStatus = scope.querySelector(deckInputConfig.CREATOR_COPY_STATUS_SELECTOR);
          var linkValidationStatus = deckInputConfig.IS_CREATOR_DECK ? scope.querySelector(deckInputConfig.DECK_LINK_VALIDATION_SELECTOR) : byId('deckLinkValidation');
          var deckLinkRefresh = byId('deckLinkRefresh')
            || scope.querySelector(deckInputConfig.CREATOR_REFRESH_LINK_SELECTOR);
          var deckRefreshHome = deckLinkRefresh && deckLinkRefresh.parentNode;
          var deckRefreshNext = deckLinkRefresh && deckLinkRefresh.nextSibling;
          var deckRefreshPending = false;
          var deckRefreshBusy = false;
          var deckRefreshCooldownUntil = 0;
          var deckRefreshCooldownTimer = null;
          var xmlStatus = byId('xmlStatus');
          var customImagesInput = byId('customImageFiles');
          var customImagesManifest = byId('customImagesManifest');
          var customImagesStatus = byId('customImagesStatus');
          var customImagesSummary = byId('customImagesSummary');
          var customImagesSize = byId('customImagesSize');
          var customImagesRangeHelp = byId('customImagesRangeHelp');
          var customImagesList = byId('customImagesList');
          var customImagesClear = byId('customImagesClear');
          var customImageSlots = [];
          var customImageFrontCount = 0;
          var customDeckValidation = { valid: false, message: '' };
          var customDeckEditor = null;
          var textValidationStatus = byId('deckTextValidation');
          var textValidationRetry = byId('deckTextRetry');
          var deckValidationField = byId('deckValidationToken');
          var deckSnapshotField = byId('deckSnapshotId');
          var deckValidationTokens = { text: '', link: '', xml: '', images: '' };
          var deckValidationKeys = { text: '', link: '', xml: '', images: '' };
          var deckValidationErrorUntil = { text: 0, link: 0 };
          var validationRequestTail = Promise.resolve();
          // Every queued or running deck check, so Refresh and the status
          // watchdog can stop a stalled one instead of waiting behind it.
          var deckRequestTickets = [];
          // The link status never spins forever: after LINK_CHECK_SLOW_MS it
          // stops the spinner and offers Refresh; after LINK_CHECK_LIMIT_MS
          // (past the 65 s request timeout) it gives up with a retry message.
          var LINK_CHECK_SLOW_MS = 15000;
          var LINK_CHECK_LIMIT_MS = 70000;
          var linkCheckSlowTimer = null;
          var linkCheckLimitTimer = null;
          var linkCheckArmed = false;
          var linkCheckMessage = '';
          var linkCheckStalled = false;
          var deckRefreshRun = 0;
          var securityError = '';
          var securityStartedAt = Date.now();
          var deckValidationVerify = root.querySelector('[data-deck-validation-verify]');
          var submitRequirements = byId('trcSubmitRequirements');
          var submitProgress = byId('trcSubmitProgress');
          var submitProgressStatus = byId('trcSubmitProgressStatus');
          var submitProgressPercent = byId('trcSubmitProgressPercent');
          var submitProgressTrack = byId('trcSubmitProgressTrack');
          var submitProgressBar = byId('trcSubmitProgressBar');
          var requirementsRevealed = false;
          var highlightedRequirements = [];
          var radios    = root.querySelectorAll('.deck-input__radio');
          var panels    = root.querySelectorAll('.deck-input__panel');
          var artRadios = root.querySelectorAll('input[name="properties[Art style]"]');
          var previewProfileField = byId('trcPreviewProfile');
          var previewRevisionField = byId('trcPreviewRevision');
          var previewSnapshotField = byId('trcPreviewSnapshot');
          var profilePreviewTimer = null;
          var profilePreviewRequest = 0;
          var profilePreviewCache = {};
          var profilePreviewResult = { text: null, link: null };
          var profilePreviewRecovery = {};
          var uploadedArtPreviews = { images: null };
          var deckValidationResult = { text: null, link: null };
          var deckValidationResultKey = { text: '', link: '' };
          var deckValidationError = { text: null, link: null };
          var deckValidationErrorKey = { text: '', link: '' };
          var profileImageCache = {};
          // Art preloads (see preloadProfileImages).
          var PROFILE_PRELOAD_CONCURRENCY = 6;
          var PROFILE_PRELOAD_PER_STYLE = 32;
          var PROFILE_PRELOAD_DELAY_MS = 1200;
          var profilePreloadQueue = [];
          var profilePreloadActive = [];
          var profilePreloadTimer = null;
          var profilePreloadSource = null;
          var profilePreviewExpanded = false;
          var stickyArtPanels = root.querySelectorAll('.deck-input__art-sticky');
          var stickyShadowFrame = null;
          function updateStickyArtShadows() {
            stickyShadowFrame = null;
            stickyArtPanels.forEach(function (panel) {
              var stickyVariants = panel.firstElementChild
                && panel.firstElementChild.classList.contains('deck-input__sticky-variants')
                ? panel.firstElementChild
                : null;
              var stickyVariantHeight = 0;
              if (stickyVariants && stickyVariants.getClientRects().length) {
                var variantStyle = window.getComputedStyle(stickyVariants);
                stickyVariantHeight = stickyVariants.offsetHeight
                  + (parseFloat(variantStyle.marginTop) || 0)
                  + (parseFloat(variantStyle.marginBottom) || 0);
              }
              panel.style.setProperty('--trc-sticky-variant-height', Math.ceil(stickyVariantHeight) + 'px');
              if (!panel.getClientRects().length) {
                panel.classList.remove('is-stuck');
                return;
              }
              var region = panel.closest('.deck-input__art-preview-region');
              if (!region) return;
              var panelRect = panel.getBoundingClientRect();
              var regionRect = region.getBoundingClientRect();
              var stickyTop = parseFloat(window.getComputedStyle(panel).top) || 0;
              var isStuck = regionRect.top < stickyTop - 1
                && Math.abs(panelRect.top - stickyTop) <= 2
                && regionRect.bottom > panelRect.bottom + 1;
              panel.classList.toggle('is-stuck', isStuck);
            });
          }
          function queueStickyArtShadowUpdate() {
            if (stickyShadowFrame !== null) return;
            stickyShadowFrame = window.requestAnimationFrame(updateStickyArtShadows);
          }
          listen(window, 'scroll', queueStickyArtShadowUpdate, { passive: true });
          listen(window, 'resize', queueStickyArtShadowUpdate);
          queueStickyArtShadowUpdate();
          // Card-back uploader (optional, on the Text + Link tabs)
          var cardbackFileInputs = root.querySelectorAll('[data-cardback-file]');
          var cardbackFields      = root.querySelectorAll('[data-cardback-field]');
          var WORKER_URL = 'https://uploads.tablereadycards.com';
          var CB_MAX_BYTES = 25 * 1024 * 1024;        // 25 MB
          var CB_TARGET_RATIO = 2176 / 2960;           // full upload ratio incl. bleed (~0.735)
          var CB_RATIO_TOLERANCE = 0.08;               // warn if >8% off 5:7
          var cardback = { text: null, link: null, images: null };  // staged image per tab: { file, name } or null
          var cardbackToken = null;                    // Turnstile token for the staged card back
          var cardbackTokenAt = 0, cardbackSpent = '';
          var cardbackWidgetId = null;                 // explicitly-rendered Turnstile widget id
          var cardbackWidgetSuffix = null;             // which tab the widget currently belongs to
          var restoringEditorCardback = false;
          if (!textarea || !urlInput || !xmlInput || !customImagesInput || !customImagesManifest || !deckValidationField) return;
          var DECK_MAX_BY_VARIANT = deckInputConfig.DECK_MAX_BY_VARIANT;
          var DECK_MIN_BY_VARIANT = deckInputConfig.DECK_MIN_BY_VARIANT;
          var VARIANT_TITLES = deckInputConfig.VARIANT_TITLES;
          var FIREBALL_FOIL_VARIANTS = deckInputConfig.FIREBALL_FOIL_VARIANTS;
          var PRODUCT_TITLE = deckInputConfig.PRODUCT_TITLE;
          var PRODUCT_URL = deckInputConfig.PRODUCT_URL;
          var PRODUCT_MAX_FALLBACK = deckInputConfig.PRODUCT_MAX_FALLBACK;
          var IS_CREATOR_DECK = deckInputConfig.IS_CREATOR_DECK;
          var IS_CUSTOM_DECK = deckInputConfig.IS_CUSTOM_DECK;
          var FOIL_TWO_SIDED_ACK = deckInputConfig.FOIL_TWO_SIDED_ACK;
          var artSelectionTouched = false;
          function clearInitialArtSelection() {
            if (artSelectionTouched) return;
            artRadios.forEach(function (radio) { radio.checked = false; });
          }
          clearInitialArtSelection();
          window.requestAnimationFrame(clearInitialArtSelection);
          listen(window, 'pageshow', clearInitialArtSelection);
          var FIXED_DECK_URL = deckInputConfig.FIXED_DECK_URL;
          var productInfoScope = root.closest('product-info') || document;
          var deckVariantPicker = IS_CUSTOM_DECK
            ? productInfoScope.querySelector('.product__block--custom-variant-picker')
            : (IS_CREATOR_DECK ? productInfoScope.querySelector('.product__block--variant_picker') : null);
          // Version the preference key so existing shoppers receive the new
          // Deck URL default once, while subsequent tab choices still persist.
          var MODE_STORAGE_KEY = deckInputConfig.MODE_STORAGE_KEY;

          var form = textarea.closest('form');
          var submitBtn = form ? form.querySelector('[name="add"]') : null;
          var submitLabel = submitBtn ? submitBtn.querySelector('[data-trc-submit-label]') : null;

          var exactQuantity = null;
          var exactRoot = root.querySelector("[data-exact-quantity]");
          var exactConfig = exactRoot ? JSON.parse(exactRoot.querySelector("[data-exact-config]").textContent) : null;

          function selectedVariantId() {
            var idField = form ? form.querySelector('[name="id"]') : null;
            return idField ? idField.value : null;
          }

          function markCreatorLinkCopied() {
            if (!creatorCopyLink) return;
            creatorCopyLink.textContent = 'COPIED';
            if (creatorCopyStatus) creatorCopyStatus.textContent = 'Moxfield link copied.';
            window.setTimeout(function () {
              creatorCopyLink.textContent = 'COPY LINK';
              if (creatorCopyStatus) creatorCopyStatus.textContent = '';
            }, 1800);
          }

          function fallbackCopyCreatorLink(value) {
            var copyField = document.createElement('textarea');
            copyField.value = value;
            copyField.setAttribute('readonly', '');
            copyField.style.position = 'fixed';
            copyField.style.opacity = '0';
            document.body.appendChild(copyField);
            copyField.select();
            var copied = document.execCommand('copy');
            copyField.remove();
            if (copied) markCreatorLinkCopied();
          }

          function copyCreatorDeckLink() {
            var value = FIXED_DECK_URL || urlInput.value.trim();
            if (!value) return;
            if (navigator.clipboard && window.isSecureContext) {
              navigator.clipboard.writeText(value).then(markCreatorLinkCopied, function () {
                fallbackCopyCreatorLink(value);
              });
              return;
            }
            fallbackCopyCreatorLink(value);
          }
          function selectedPrintType() {
            var scope = root.closest('product-info') || document;
            var control = scope.querySelector(
              'select[name="options[Print Type]"], input[name="options[Print Type]"]:checked'
            );
            return control ? control.value : '';
          }
          var lastFoilPreviewState = null;
          function foilSelected() {
            // Follow the variant the form will actually add. The option control
            // can run ahead of it while the theme is still loading that variant.
            var formVariant = String(selectedVariantId() || '');
            var printType = exactQuantity ? exactQuantity.finish()
              : (formVariant && Object.keys(FIREBALL_FOIL_VARIANTS).length ? '' : selectedPrintType());
            return printType
              ? printType.indexOf('Fireball Foil') !== -1
              : !!FIREBALL_FOIL_VARIANTS[formVariant];
          }
          function syncFoilPreview() {
            var enabled = foilSelected();
            root.setAttribute('data-foil-selected', enabled ? 'true' : 'false');
            document.body.classList.toggle('trc-fireball-foil-selected', enabled);
            if (lastFoilPreviewState !== enabled) {
              lastFoilPreviewState = enabled;
              document.dispatchEvent(new CustomEvent('trc:foil-change', { detail: { selected: enabled } }));
            }
            syncTwoSidedNotice();
          }
          // --- Fireball Foil: fronts only ---
          // While foil is selected the notes under the deck preview say foil prints
          // on card fronts only, with the number of two-sided cards when it is known (a card
          // with a printed back: a double-faced card or a card with its own
          // back). The cart line records that number. No lookup, no count: text
          // and link decks use only the upload Worker's twoSided field and never
          // guess from card names.
          function positiveCount(value) {
            var n = Number(value);
            return Number.isInteger(n) && n > 0 ? n : 0;
          }
          // The active tab's two-sided card count while Fireball Foil is selected, else 0.
          function currentTwoSided() {
            var mode = currentMode();
            if (!foilSelected()) return 0;
            if (mode === 'text' || mode === 'link') {
              var result = deckValidationResult[mode];
              return result && result.twoSided && deckValidationResultKey[mode] === profilePreviewCacheKey(mode) ? positiveCount(result.twoSided.count) : 0;
            }
            if (mode === 'xml') {
              var staged = xmlText != null || /\|https?:\/\//.test(xmlInput.value);
              return staged ? positiveCount(xmlTwoSided) : 0;
            }
            if (mode === 'images' && customImageFrontCount > 0) {
              return customImageSlots.filter(function (slot) { return !!slot && slot.backFileIndex != null; }).length;
            }
            return 0;
          }
          function foilNoteText(count) {
            return 'Foil prints on card fronts only.' + (count === 1
              ? ' This deck has 1 two-sided card, so its back prints without foil.'
              : count > 1 ? ' This deck has ' + count + ' two-sided cards, so their backs print without foil.' : '');
          }
          // The visible "Two-sided cards" line property (never "Print Type" or "Foiling").
          function twoSidedPropertyValue(count) {
            return count === 1 ? '1 (back prints without foil)' : count > 1 ? count + ' (backs print without foil)' : '';
          }
          // The foil line's place on a tab: under its rendered preview, with the art style notes (the XML tab's
          // preview has its own). No preview, no place, so no line.
          function foilNoteSlot(mode) {
            return root.querySelector('[data-panel="' + mode + '"] [data-foil-note]');
          }
          // Keeps the foil line and the line property in step. Runs on every
          // validation pass, every preview render and every finish change, so
          // entering the deck first and choosing foil later (or the reverse)
          // lands the same way.
          // Per tab: the confirmation's message key and whether it is ticked, so a re-rendered preview (a printings
          // recheck, another art style, coming back to the tab) keeps the tick while its message is unchanged.
          var twoSidedAckState = {};
          function syncTwoSidedNotice() {
            var foil = foilSelected();
            var count = currentTwoSided();
            var mode = currentMode();
            var note = foilNoteSlot(mode);
            // Hiding the message resets every confirmation; a new count for this tab resets its own.
            if (!foil) twoSidedAckState = {};
            var ackKey = count + '|' + FOIL_TWO_SIDED_ACK + '|' + mode;
            if (!twoSidedAckState[mode] || twoSidedAckState[mode].key !== ackKey) twoSidedAckState[mode] = {key: ackKey, checked: false};
            var ackState = twoSidedAckState[mode];
            // One message: another tab's line is cleared (with its confirmation).
            Array.prototype.forEach.call(root.querySelectorAll('[data-foil-note]'), function (slot) {
              if (slot === note || slot._trcFoilKey === '') return;
              slot._trcFoilKey = '';
              slot.hidden = true;
              slot.replaceChildren();
            });
            var key = foil ? count + '|' + FOIL_TWO_SIDED_ACK : '';
            if (note && note._trcFoilKey !== key) {
              note._trcFoilKey = key;
              note.hidden = !foil;
              note.classList.toggle('has-two-sided', count > 0);
              // A new message starts with the confirmation unchecked; the same message keeps its tick.
              note.replaceChildren();
              if (foil) {
                // Only the sentence is a live region, never the confirmation checkbox beside it.
                var copy = document.createElement('p');
                copy.setAttribute('role', 'status');
                copy.textContent = foilNoteText(count);
                note.appendChild(copy);
              }
              if (count > 0 && FOIL_TWO_SIDED_ACK) {
                var ack = document.createElement('label');
                ack.className = 'deck-input__check';
                var check = document.createElement('input');
                check.type = 'checkbox';
                check.required = true;
                check.setAttribute('data-two-sided-ack', '');
                check.checked = ackState.checked;
                check.addEventListener('change', function () { ackState.checked = check.checked; validate(); });
                var ackCopy = document.createElement('span');
                ackCopy.textContent = 'I understand that foil prints on card fronts only.';
                ack.appendChild(check);
                ack.appendChild(ackCopy);
                note.appendChild(ack);
              }
            }
            var field = root.querySelector('[data-two-sided-field]');
            if (field) {
              field.value = twoSidedPropertyValue(count);
              field.disabled = !field.value;
            }
            // While the confirmation is shown, Buy it now (which skips it) is hidden. Deck builder
            // products never show that button today; this keeps it true if they ever do.
            if (form) form.classList.toggle('trc-two-sided-ack-open', count > 0 && !!FOIL_TWO_SIDED_ACK && !!note && !!note.querySelector('[data-two-sided-ack]'));
            return count;
          }
          function twoSidedAckMissing() {
            if (!FOIL_TWO_SIDED_ACK) return null;
            var note = foilNoteSlot(currentMode());
            var check = note && !note.hidden && !note.closest('[hidden]') ? note.querySelector('[data-two-sided-ack]') : null;
            return check && !check.checked ? check.closest('label') : null;
          }
          function currentRange() {
            var vid = selectedVariantId();
            return F.variantCountRange({configuredMaximum: vid ? DECK_MAX_BY_VARIANT[vid] : 0, configuredMinimum: DECK_MIN_BY_VARIANT[vid],
              variantTitle: vid && VARIANT_TITLES[vid], productTitle: PRODUCT_TITLE, fallbackMaximum: PRODUCT_MAX_FALLBACK, exact: !!exactConfig});
          }
          function currentTarget() { return currentRange().maximum; }
          function currentMinimum() { return currentRange().minimum; }
          var TARGET = currentTarget();
          var MINIMUM = currentMinimum();
          var validationVariantId = selectedVariantId();
          function cardWord(count) { return F.cardWord(count); }
          // D-5: products whose print options name the board ("75 Cards (Mainboard +
          // Sideboard)", "60 Cards (Mainboard Only)") carry no board choice: the
          // selected option decides what a deck link includes.
          var boardByVariant = !!(sideboardCheck && sideboardCheck.hasAttribute('data-deck-contents-by-variant'));
          function syncVariantDeckContents() {
            if (!boardByVariant) return false;
            var next = variantDeckContents(VARIANT_TITLES && VARIANT_TITLES[selectedVariantId()]) || 'Mainboard';
            if (sideboardCheck.value === next) return false;
            sideboardCheck.value = next;
            return true;
          }
          // A fixed-size print option (not an any-quantity product or a creator
          // deck) still takes a shorter deck, after the shopper confirms it.
          var underCountConfirmed = false;
          function underCountMessage(count) {
            // "Up to N Cards" options are a ceiling, never a fixed size.
            return F.underCountMessage(count, TARGET, {exact: !!exactConfig, creatorDeck: IS_CREATOR_DECK, variantTitle: VARIANT_TITLES && VARIANT_TITLES[selectedVariantId()]});
          }
          function validatedCount(mode) {
            if (mode === 'text') return cardCount;
            if (mode === 'xml') return xmlCardCount;
            if (mode === 'link') {
              var result = deckValidationResult.link;
              return result && deckValidationResultKey.link === profilePreviewCacheKey('link') && !result.requiresCompanionChoice ? Number(result.count) || 0 : 0;
            }
            return 0;
          }
          function refreshSizeLabel() {
            if (customImagesRangeHelp) {
              customImagesRangeHelp.textContent = TARGET;
            }
            if (customImagesManifest && customImagesManifest.value) {
              customImagesManifest.value = '';
              clearDeckValidation();
            }
            if (customDeckEditor && !exactConfig) customDeckEditor.setLimits(1, TARGET);
            renderCustomImages();
          }

          // --- Turnstile token plumbing ---
          var turnstileToken = null;
          var deckValidationWidgetId = null;
          var deckChallengeGeneration = 0;
          var deckChallengeInteractive = false;
          var deckSecurityCode = '';
          var deckTokenWaiters = 0;
          var turnstileTokenAt = 0;
          var spentDeckTokens = {};
          // Tokens are single-use and expire after 300 s: one held longer
          // than this (an idle tab, a page back from the back-forward cache)
          // is replaced before it is sent.
          var TOKEN_MAX_AGE_MS = 240000;
          // A rejected token (expired or already used) is retried once with a
          // fresh one; only a second failure shows this copy.
          var SECURITY_FAILED_COPY = 'We couldn\u2019t confirm you\u2019re a person. Please try again.';
          function securityRejection(data, status) {
            var code = String(data && data.code || '');
            if (!/^turnstile_/.test(code) && !(status === 401 && /turnstile/i.test(String(data && data.error || '')))) return null;
            var error = new Error(code === 'turnstile_hostname' ? 'Please open this page on tablereadycards.com.'
              : code === 'turnstile_unavailable' ? 'Our security check is not responding. Please try again in a moment.' : SECURITY_FAILED_COPY);
            error.turnstile = code || 'turnstile_invalid';
            return error;
          }
          // Hostname and action failures repeat with any token: never retried.
          function retrySecurity(error) { return !!(error && error.turnstile) && !/_(hostname|action)$/.test(error.turnstile); }
          // An outage waits its Retry-After (at most 5 s) before the one retry.
          function securityRetryWait(error) {
            var ms = error.turnstile === 'turnstile_unavailable' ? Math.min(5, Number(error.retryAfterSeconds) || 5) * 1000 : 0;
            return new Promise(function (resolve) { if (ms) window.setTimeout(resolve, ms); else resolve(); });
          }
          var deckSecurityStatus = root.querySelector('[data-deck-security-status]');
          var customImagesToken = null;
          var customImagesTokenAt = 0;
          var lastConsumedCustomImagesToken = '';
          var customImagesTokenPromise = null;
          var customImagesTokenResolve = null;
          var customImagesTokenReject = null;
          var customImagesTokenTimer = null;
          var customImagesVerify = byId('trcCustomImagesTurnstile');
          var customImagesWidgetId = null;
          // The custom images challenge solves as soon as it renders, so it is
          // rendered only once this product needs it (the Custom Images tab, or
          // an upload asking for a token), never beside the deck check on a
          // link or text page load where both would compete.
          var customImagesWidgetWanted = false;
          var customImagesFirstChallenge = false;   // rendered, first answer not in yet
          var turnstileWidgetsStarted = false;
          var turnstileInitTimer = null;

          function resolveCustomImagesToken(token) {
            customImagesFirstChallenge = false;
            // Turnstile tokens are single-use: never hand out one already spent.
            if (token && token === lastConsumedCustomImagesToken) return;
            customImagesToken = token;
            customImagesTokenAt = Date.now();
            if (customImagesTokenTimer) window.clearTimeout(customImagesTokenTimer);
            if (customImagesTokenResolve) customImagesTokenResolve(token);
            customImagesTokenPromise = null;
            customImagesTokenResolve = null;
            customImagesTokenReject = null;
            customImagesTokenTimer = null;
            renderCustomImages();
            validate();
          }

          function rejectCustomImagesToken(message) {
            customImagesToken = null;
            if (customImagesTokenTimer) window.clearTimeout(customImagesTokenTimer);
            if (customImagesTokenReject) customImagesTokenReject(new Error(message || 'Upload verification failed. Please try again.'));
            customImagesTokenPromise = null;
            customImagesTokenResolve = null;
            customImagesTokenReject = null;
            customImagesTokenTimer = null;
            validate();
          }

          function ensureTurnstileWidgets() {
            if (lifecycle.signal.aborted) return false;
            turnstileWidgetsStarted = true;
            if (!window.turnstile || typeof window.turnstile.render !== 'function') {
              loadTurnstileApi();
              if (Date.now() - securityStartedAt > 30000) {
                securityError = 'The security check could not load. Check your connection or content blocker, then retry.';
                validate();
                return false;
              }
              if (!turnstileInitTimer) {
                turnstileInitTimer = window.setTimeout(function () {
                  turnstileInitTimer = null;
                  ensureTurnstileWidgets();
                }, 250);
              }
              return false;
            }
            if (deckValidationVerify && deckValidationWidgetId === null) {
              var challengeGeneration = ++deckChallengeGeneration;
              function isCurrentChallenge() { return !lifecycle.signal.aborted && challengeGeneration === deckChallengeGeneration; }
              try { deckValidationWidgetId = window.turnstile.render(deckValidationVerify, {
                sitekey: deckValidationVerify.getAttribute('data-sitekey'),
                action: deckValidationVerify.getAttribute('data-action') || 'trc-deck-validation',
                appearance: 'interaction-only',
                callback: function (token) {
                  if (!isCurrentChallenge() || spentDeckTokens[token]) return;
                  turnstileToken = token;
                  turnstileTokenAt = Date.now();
                  securityError = "";
                  deckSecurityCode = '';
                  deckChallengeInteractive = false;
                  validate();
                  if (deckRefreshPending) performDeckRefresh();
                  else {
                    // A reset can finish before the preceding response handler.
                    // Do not supersede that handler (especially its retry error).
                    var pending = profilePreviewCache[profilePreviewCacheKey(currentMode())];
                    if (!pending || typeof pending.then !== 'function') scheduleProfilePreview(currentMode());
                  }
                },
                'error-callback': function (code) {
                  if (!isCurrentChallenge()) return true;
                  turnstileToken = null;
                  deckChallengeInteractive = false;
                  deckSecurityCode = /^\d{6}$/.test(String(code)) ? String(code) : '';
                  securityError = 'The security check could not finish. Please retry.' + (deckSecurityCode ? ' (Security code ' + deckSecurityCode + ')' : '');
                  showLinkCheckProgress();
                  validate();
                  return true;
                },
                'expired-callback': function () { if (isCurrentChallenge()) { turnstileToken = null; validate(); } },
                'timeout-callback': function () {
                  if (!isCurrentChallenge()) return;
                  turnstileToken = null;
                  deckChallengeInteractive = false;
                  securityError = 'The security check expired. Please retry and complete the check above.';
                  validate();
                },
                'before-interactive-callback': function () {
                  if (!isCurrentChallenge()) return;
                  deckChallengeInteractive = true;
                  showDeckSecurityStatus('');
                  showLinkCheckProgress();
                  validate();
                },
                'after-interactive-callback': function () { if (isCurrentChallenge()) { deckChallengeInteractive = false; restartLinkCheckLimit(); showLinkCheckProgress(); validate(); } },
              }); } catch (error) {
                securityError = 'The security check could not start. Reload this page and try again.';
                validate();
                return false;
              }
            }
            if (customImagesVerify && customImagesWidgetWanted && customImagesWidgetId === null) {
              // A render that throws leaves no widget: a waiting upload gets the
              // usual error and the next token request tries again.
              try { customImagesWidgetId = window.turnstile.render(customImagesVerify, {
                sitekey: customImagesVerify.getAttribute('data-sitekey'),
                action: customImagesVerify.getAttribute('data-action') || 'trc-custom-images',
                callback: resolveCustomImagesToken,
                'error-callback': function () {
                  customImagesFirstChallenge = false;
                  rejectCustomImagesToken('Upload verification failed. Check your connection and blockers for this site, then try Add to cart again.');
                },
                'expired-callback': function () {
                  customImagesFirstChallenge = false;
                  customImagesToken = null;
                  if (customImagesTokenPromise) refreshCustomImagesChallenge();
                  validate();
                },
              }); } catch (error) {
                customImagesWidgetId = null;
                customImagesFirstChallenge = false;
                rejectCustomImagesToken('Upload verification failed. Check your connection and blockers for this site, then try Add to cart again.');
                return true;
              }
              customImagesFirstChallenge = customImagesWidgetId !== null;
            }
            return true;
          }

          // Start the custom images challenge (once). Before the page's widgets
          // start, this only marks it wanted and they render it with the deck check.
          function wantCustomImagesWidget() {
            if (!customImagesVerify) return;
            customImagesWidgetWanted = true;
            if (turnstileWidgetsStarted && customImagesWidgetId === null) ensureTurnstileWidgets();
          }

          function currentCustomImagesToken() {
            // Too old to send: retire it (the widget's copy too) for a fresh one.
            if (customImagesToken && Date.now() - customImagesTokenAt > TOKEN_MAX_AGE_MS) {
              lastConsumedCustomImagesToken = customImagesToken;
              customImagesToken = null;
            }
            if (customImagesToken) return customImagesToken;
            customImagesWidgetWanted = true;
            if (!ensureTurnstileWidgets() || customImagesWidgetId === null) return '';
            try {
              var response = window.turnstile.getResponse(customImagesWidgetId) || '';
              return response === lastConsumedCustomImagesToken ? '' : response;
            } catch (ignore) {
              return '';
            }
          }

          // Mark a token as spent the moment it is handed to an upload, and ask
          // the widget for a fresh one so the next deck (or a retry) never reuses it.
          function consumeCustomImagesToken(token) {
            lastConsumedCustomImagesToken = token || '';
            if (customImagesToken === token) customImagesToken = null;
            if (window.turnstile && customImagesWidgetId !== null) {
              try { window.turnstile.reset(customImagesWidgetId); } catch (ignore) {}
            }
            return token;
          }

          function refreshCustomImagesChallenge() {
            if (lifecycle.signal.aborted) return;
            var existingToken = currentCustomImagesToken();
            if (existingToken) {
              resolveCustomImagesToken(existingToken);
              return;
            }
            if (!window.turnstile || customImagesWidgetId === null) {
              // Retry only while an upload waits (a render that failed has
              // already answered it; the next request tries again).
              if (customImagesTokenPromise) window.setTimeout(refreshCustomImagesChallenge, 250);
              return;
            }
            // A widget that just rendered is still solving its first challenge:
            // its callback answers the waiting upload, and a reset would only
            // restart it. Later calls reset as before.
            if (customImagesFirstChallenge) {
              customImagesFirstChallenge = false;
              return;
            }
            try {
              window.turnstile.reset(customImagesWidgetId);
            } catch (ignore) {}
          }

          function waitForCustomImagesToken() {
            var availableToken = currentCustomImagesToken();
            if (availableToken) {
              // Recovered from the widget (no callback): its age starts now.
              if (availableToken !== customImagesToken) customImagesTokenAt = Date.now();
              customImagesToken = availableToken;
              return Promise.resolve(availableToken);
            }
            if (customImagesTokenPromise) return customImagesTokenPromise;
            // Kept here too: a challenge that fails at once answers (and clears)
            // customImagesTokenPromise before this returns.
            var pending = customImagesTokenPromise = new Promise(function (resolve, reject) {
              customImagesTokenResolve = resolve;
              customImagesTokenReject = reject;
              customImagesTokenTimer = window.setTimeout(function () {
                customImagesTokenPromise = null;
                customImagesTokenResolve = null;
                customImagesTokenReject = null;
                customImagesTokenTimer = null;
                reject(new Error('Upload verification timed out. Please try Add to cart again.'));
              }, 30000);
            });
            if (customImagesStatus) customImagesStatus.textContent = 'Preparing secure upload…';
            refreshCustomImagesChallenge();
            return pending;
          }

          function applyDeckValidation(mode) {
            var token = deckValidationKeys[mode] === profilePreviewCacheKey(mode) ? (deckValidationTokens[mode] || '') : '';
            deckValidationField.value = token;
            deckValidationField.disabled = !token;
            // A linked deck's saved copy (what prints): the id its proof signs.
            if (deckSnapshotField) {
              var snapshot = proofDeckSnapshot(token);
              deckSnapshotField.value = snapshot;
              deckSnapshotField.disabled = !snapshot;
            }
          }

          function proofDeckSnapshot(token) {
            try {
              var body = String(token || '').split('.')[0];
              if (!body) return '';
              body = body.replace(/-/g, '+').replace(/_/g, '/');
              while (body.length % 4) body += '=';
              var claims = JSON.parse(atob(body));
              return claims && claims.mode === 'link' && /^[0-9a-f]{64}$/.test(String(claims.deckSnapshot || '')) ? String(claims.deckSnapshot) : '';
            } catch (ignore) { return ''; }
          }

          function setDeckValidation(mode, token) {
            deckValidationTokens[mode] = token || '';
            deckValidationKeys[mode] = token ? profilePreviewCacheKey(mode) : '';
            if (currentMode() === mode) applyDeckValidation(mode);
          }

          function clearProfilePreview(mode) {
            profilePreviewResult[mode] = null;
            var preview = root.querySelector('[data-profile-preview="' + mode + '"]');
            if (preview) {
              clearProfilePreviewDisclosure(preview);
              preview.hidden = true;
              preview.textContent = '';
              preview.classList.remove('is-loading');
            }
            if (currentMode() === mode) {
              [previewProfileField, previewRevisionField, previewSnapshotField].forEach(function (field) {
                if (!field) return;
                field.value = '';
                field.disabled = true;
              });
            }
          }

          function clearDeckValidation(mode) {
            mode = mode || currentMode();
            underCountConfirmed = false;
            if (exactQuantity && mode === currentMode()) exactQuantity.invalidate();
            profilePreviewRequest++;
            deckValidationTokens[mode] = '';
            deckValidationKeys[mode] = '';
            if (mode === 'xml' && xmlText) xmlInput.value = 'ready';
            if (mode === 'text' || mode === 'link') {
              if (mode === currentMode()) cancelProfileImagePreloads();
              deckValidationResult[mode] = null;
              deckValidationResultKey[mode] = '';
              deckValidationError[mode] = null;
              deckValidationErrorKey[mode] = '';
              deckValidationErrorUntil[mode] = 0;
            }
            if (mode === 'text') updateTextValidationStatus();
            if (mode === 'link') updateLinkValidationStatus();
            if (mode === 'link') updateDeckRefreshButton();
            clearProfilePreview(mode);
            // A custom back proof is bound to the exact active-deck proof. If
            // the deck changes, retain the original local file but stage it
            // for a fresh, correctly bound upload before cart submission.
            var uploadedCardback = cbEl('cardback-field', mode);
            if (uploadedCardback && /\|https?:\/\//.test(uploadedCardback.value) && cardback[mode]) {
              uploadedCardback.value = '';
              uploadedCardback.disabled = true;
              if (currentMode() === mode) ensureCardbackTurnstile(mode);
            }
            if (currentMode() === mode) applyDeckValidation(mode);
          }

          function showDeckSecurityStatus(message) {
            if (!deckSecurityStatus) return;
            deckSecurityStatus.textContent = message || '';
            deckSecurityStatus.hidden = !message || currentMode() === 'images';
          }

          function resetDeckValidationChallenge(recreate) {
            turnstileToken = null;
            if (recreate) {
              ++deckChallengeGeneration;
              if (window.turnstile && deckValidationWidgetId !== null) {
                try { window.turnstile.remove(deckValidationWidgetId); } catch (ignore) {}
              }
              deckValidationWidgetId = null;
              deckChallengeInteractive = false;
              deckSecurityCode = '';
              securityError = '';
              securityStartedAt = Date.now();
              ensureTurnstileWidgets();
              return;
            }
            // A reset widget starts a new challenge; an interactive one says so again.
            deckChallengeInteractive = false;
            if (window.turnstile && deckValidationWidgetId !== null) {
              try { window.turnstile.reset(deckValidationWidgetId); } catch (ignore) { resetDeckValidationChallenge(true); }
            }
          }

          function uploadDecklist(xmlString) {
            var variantId = selectedVariantId();
            return secureDeckRequest(function (token, signal) {
              return fetch(WORKER_URL + '?variantId=' + encodeURIComponent(variantId), {
                method: 'POST', headers: {'Content-Type': 'application/xml', 'CF-Turnstile-Response': token}, body: xmlString, signal: signal
              }).then(readDeckResponse);
            });
          }

          function readDeckResponse(res) {
            return res.json().catch(function () { return {error: 'Deck validation failed'}; }).then(function (data) {
              if (!res.ok) {
                var requestId = res.headers.get('X-TRC-Request-ID') || data.requestId || '';
                var error = securityRejection(data, res.status) || new Error(data.error || 'Deck validation failed');
                error.status = res.status;
                error.requestId = requestId;
                error.validation = data;
                error.retryAfterSeconds = Number(data.retryAfterSeconds || res.headers.get('Retry-After')) || 5;
                throw error;
              }
              return data;
            });
          }

          function waitForDeckToken(stillCurrent, ticket) {
            var deadline = Date.now() + 30000;
            var recoveryAt = Date.now() + 12000;
            var recovered = false;
            var interactiveDeadline = 0;
            deckTokenWaiters++;
            showDeckSecurityStatus('Running a quick security check…');
            ensureTurnstileWidgets();
            validate();
            return new Promise(function (resolve, reject) {
              function check() {
                if (ticket && ticket.cancelled) return reject(ticket.error);
                if (lifecycle.signal.aborted) return reject(new Error('Product closed.'));
                if (stillCurrent && !stillCurrent()) return reject(new Error(F.MESSAGES.deckChanged));
                // Recover an already-completed iframe response if its callback
                // was delayed. Never reuse a single-use token.
                if (turnstileToken && Date.now() - turnstileTokenAt > TOKEN_MAX_AGE_MS) {
                  spentDeckTokens[turnstileToken] = 1;
                  resetDeckValidationChallenge();
                }
                if (!turnstileToken && window.turnstile && deckValidationWidgetId !== null) {
                  try {
                    var response = window.turnstile.getResponse(deckValidationWidgetId);
                    var expired = typeof window.turnstile.isExpired === 'function' && window.turnstile.isExpired(deckValidationWidgetId);
                    if (response && !spentDeckTokens[response] && !expired) { turnstileToken = response; turnstileTokenAt = Date.now(); }
                  } catch (ignore) {}
                }
                if (turnstileToken) {
                  var token = turnstileToken;
                  turnstileToken = null;
                  spentDeckTokens[token] = 1;
                  return resolve(token);
                }
                // Give a visible human challenge time to be completed; never
                // remove it while the visitor is interacting with it.
                if (deckChallengeInteractive && !interactiveDeadline) {
                  interactiveDeadline = Date.now() + 120000;
                  deadline = Math.max(deadline, interactiveDeadline);
                }
                if (!recovered && !interactiveDeadline && Date.now() >= recoveryAt && window.turnstile && typeof window.turnstile.render === 'function') {
                  recovered = true;
                  resetDeckValidationChallenge(true);
                  // A phone may resume after its original deadline. Give the
                  // single fresh attempt time to finish instead of rejecting it
                  // in the same timer tick that created it.
                  deadline = Math.max(deadline, Date.now() + 15000);
                  showDeckSecurityStatus('The security check stalled. Trying a fresh check…');
                }
                if (Date.now() >= (deckChallengeInteractive ? interactiveDeadline : deadline)) {
                  securityError = securityError || 'The security check could not finish. ' + (currentMode() === 'link' ? 'Use Refresh. If it happens again, reload the page' : 'Reload the page') + ' and check whether a content blocker is blocking the security check.';
                  return reject(new Error(securityError));
                }
                window.setTimeout(check, 100);
              }
              check();
            }).finally(function () {
              deckTokenWaiters--;
              if (!deckTokenWaiters) showDeckSecurityStatus('');
              if (!lifecycle.signal.aborted) validate();
            });
          }

          function secureDeckRequest(request, stillCurrent) {
            // A ticket can be cancelled while it is queued, waiting for the
            // security check or waiting for the Worker (Refresh, watchdog).
            var ticket = {cancelled: false, error: null, cancel: null, requestStartedAt: 0};
            var cancelled = new Promise(function (_, reject) {
              ticket.cancel = function (message) {
                if (ticket.cancelled) return;
                ticket.cancelled = true;
                ticket.error = new Error(message || 'Deck check stopped. Please retry.');
                ticket.error.cancelled = true;
                reject(ticket.error);
              };
            });
            cancelled.catch(function () {});
            deckRequestTickets.push(ticket);
            var queued = validationRequestTail.catch(function () {}).then(function () {
              if (ticket.cancelled) throw ticket.error;
              if (stillCurrent && !stillCurrent()) throw new Error(F.MESSAGES.deckChanged);
              return attempt(false);
            }).finally(function () {
              var index = deckRequestTickets.indexOf(ticket);
              if (index !== -1) deckRequestTickets.splice(index, 1);
            });
            validationRequestTail = queued.catch(function () {});
            return queued;

            // A security rejection is sent again once, silently, with a fresh
            // token (the finally below has already reset the widget).
            function attempt(retried) {
              return Promise.race([waitForDeckToken(stillCurrent, ticket), cancelled]).then(function (token) {
                var controller = new AbortController();
                var timer;
                var challengeGeneration = deckChallengeGeneration;
                return Promise.race([
                  Promise.resolve().then(function () {
                    if (stillCurrent && !stillCurrent()) throw new Error(F.MESSAGES.deckChanged);
                    // The status watchdog never cuts this phase short: the
                    // Worker may take up to the 65 s timeout below.
                    ticket.requestStartedAt = Date.now();
                    return request(token, controller.signal);
                  }),
                  cancelled,
                  new Promise(function (_, reject) { timer = window.setTimeout(function () { reject(new Error('Deck validation timed out. Please retry.')); }, 65000); })
                ]).finally(function () {
                  window.clearTimeout(timer);
                  controller.abort();
                  // A Refresh may already have recreated the widget for the next
                  // check; resetting that new widget would restart its challenge.
                  if (challengeGeneration === deckChallengeGeneration) resetDeckValidationChallenge();
                });
              }).catch(function (error) {
                if (retried || ticket.cancelled || !retrySecurity(error) || (stillCurrent && !stillCurrent())) throw error;
                return securityRetryWait(error).then(function () {
                  if (ticket.cancelled) throw ticket.error;
                  if (stillCurrent && !stillCurrent()) throw error;
                  return attempt(true);
                });
              });
            }
          }

          function cancelDeckRequests(message) {
            deckRequestTickets.slice().forEach(function (ticket) { ticket.cancel(message); });
          }

          // A deck link the Worker has already read (this shopper or any other,
          // in the last 10 minutes; a creator deck for longer) is answered from
          // its cache with no security check (?cache=only), usually in well
          // under a second. Resolves null when that is not possible (not
          // cached, an older Worker, an error or a slow answer), and the
          // caller runs the normal check. It is a ticket like the others, so
          // Refresh and the status watchdog can stop it.
          var CACHED_CHECK_TIMEOUT_MS = 6000;
          function cachedDeckCheck(action, body, stillCurrent) {
            if (typeof window.fetch !== 'function' || (stillCurrent && !stillCurrent())) return Promise.resolve(null);
            var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
            var ticket = {cancelled: false, error: null, cancel: null, requestStartedAt: Date.now()};
            var timer = null;
            var cancelled = new Promise(function (_, reject) {
              ticket.cancel = function (message) {
                if (ticket.cancelled) return;
                ticket.cancelled = true;
                ticket.error = new Error(message || 'Deck check stopped. Please retry.');
                ticket.error.cancelled = true;
                if (controller) controller.abort();
                reject(ticket.error);
              };
            });
            cancelled.catch(function () {});
            deckRequestTickets.push(ticket);
            var answer;
            try {
              // text/plain keeps this a simple request (no CORS preflight).
              answer = window.fetch(WORKER_URL + '?type=deck-validation&action=' + encodeURIComponent(action) + '&cache=only', {
                method: 'POST', headers: {'Content-Type': 'text/plain'}, body: JSON.stringify(body), signal: controller ? controller.signal : undefined
              }).then(function (res) {
                if (!res || !res.ok) return null;
                return res.json().then(function (data) { return data && data.ok === true ? data : null; }, function () { return null; });
              }, function () { return null; });
            } catch (ignore) {
              answer = Promise.resolve(null);
            }
            var slow = new Promise(function (resolve) {
              timer = window.setTimeout(function () { if (controller) controller.abort(); resolve(null); }, CACHED_CHECK_TIMEOUT_MS);
            });
            return Promise.race([answer, slow, cancelled]).then(function (data) {
              if (data && stillCurrent && !stillCurrent()) throw new Error(F.MESSAGES.deckChanged);
              return data;
            }).finally(function () {
              window.clearTimeout(timer);
              var index = deckRequestTickets.indexOf(ticket);
              if (index !== -1) deckRequestTickets.splice(index, 1);
            });
          }

          function validDeckUrl(value) {
            return !!canonicalDeckUrl(value);
          }
          // D-8: a link the page can read, rewritten to its canonical form
          // (a scheme-less or Moxfield tab link) so the field shows what is checked.
          function canonicalizeUrlInput() {
            if (IS_CREATOR_DECK) return false;
            var canonical = canonicalDeckUrl(urlInput.value);
            if (!canonical || canonical === urlInput.value.trim()) return false;
            urlInput.value = canonical;
            return true;
          }

          function selectedArtStyle(mode) {
            var selected = root.querySelector('input[name="properties[Art style]"][data-art="' + mode + '"]:checked');
            return selected ? selected.value : '';
          }

          function profilePreviewCacheKey(mode) {
            // Text is keyed on the same whitespace-normalized list the Worker signs,
            // so an Enter or trailing space reuses the verified result instead of
            // spending another validation request.
            var payload = mode === 'text' ? normalizeDecklistText(textarea.value)
              : mode === 'xml' ? (xmlText || xmlInput.value)
              : mode === 'images' ? customImagesManifest.value
              : urlInput.value.trim() + '\n' + (sideboardCheck ? sideboardCheck.value : 'Mainboard');
            return [mode, selectedVariantId(), payload, mode === 'link' ? String(companionChoice()) : ''].join('\n');
          }

          var COMPANION_PRICES = deckInputConfig.COMPANION_PRICES;
          function syncCompanionPrices() {
            if (!companionPanel) return;
            var productInfo = root.closest('product-info');
            if (!productInfo) return;
            var included = companionIncluded && !!companionOptions && currentMode() === 'link';
            function setPrice(node, prices) {
              if (!node || !prices || !prices.available) return;
              var value = included ? prices.total : prices.base;
              if (node.textContent.trim() !== value) node.textContent = value;
            }
            productInfo.querySelectorAll('[data-companion-price-variant]').forEach(function (node) {
              setPrice(node, COMPANION_PRICES[node.dataset.companionPriceVariant]);
            });
            productInfo.querySelectorAll('[id^="price-"] .f-price-item--regular, [id^="price-"] .f-price-item--sale').forEach(function (node) {
              if (node.tagName !== 'S') setPrice(node, COMPANION_PRICES[selectedVariantId()]);
            });
          }
          var companionPanel = null;
          var companionOptions = null;
          var companionIncluded = false;
          if (root.hasAttribute('data-commander-companion')) {
            companionPanel = document.createElement('div');
            companionPanel.hidden = true;
            companionPanel.className = 'deck-input__companion';
            companionPanel.style.cssText = 'margin:16px 0';
            companionPanel.innerHTML = '<span data-companion-name aria-live="polite" style="display:block;margin:0 0 12px"></span><button type="button" class="deck-input__companion-tile" data-companion-toggle aria-pressed="false"><span class="variant-price-card"><span class="variant-price-card__value" data-companion-label></span><span class="variant-price-card__price" data-companion-price></span></span></button>';
            linkValidationStatus.after(companionPanel);
            listen(companionPanel.querySelector('[data-companion-toggle]'), 'click', function () {
              companionIncluded = !companionIncluded;
              clearDeckValidation('link');
              showCompanion(companionOptions);
              validate();
              scheduleProfilePreview('link');
            });
          }
          function companionChoice() {
            return companionIncluded;
          }
          function clearCompanion() {
            companionOptions = null;
            if (!companionPanel) return;
            companionPanel.hidden = true;
            companionIncluded = false;
            syncCompanionPrices();
          }
          function showCompanion(companion) {
            if (!companionPanel) return;
            companionOptions = companion;
            companionPanel.hidden = !companion;
            syncCompanionPrices();
            if (!companion) return;
            var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:companion.currency});
            companionPanel.querySelector('[data-companion-name]').textContent = companionIncluded ? 'Companion added: ' + companion.name : 'Companion detected: ' + companion.name;
            var toggle = companionPanel.querySelector('[data-companion-toggle]');
            toggle.querySelector('[data-companion-label]').textContent = companionIncluded ? 'Remove companion' : (companion.available ? 'Add companion' : 'Companion unavailable');
            toggle.querySelector('[data-companion-price]').textContent = money.format(companion.extraPriceCents / 100);
            toggle.disabled = currentMode() !== 'link' || (!companionIncluded && !companion.available);
            toggle.setAttribute('aria-pressed', String(companionIncluded));
          }
          if (form) listen(form, 'formdata', function (event) {
            if (currentMode() !== 'link') return;
            var result = deckValidationResult.link;
            if (!result || !result.submission || !deckValidationField.value || deckValidationResultKey.link !== profilePreviewCacheKey('link')) return;
            // The Worker signs this snapshot and the paid variant. Preserve both
            // so fulfillment prints exactly the accepted 100 or 101 cards.
            event.formData.set('id', result.submission.variantId);
            event.formData.set('properties[_Input method]', 'Text input');
            event.formData.set('properties[Decklist]', result.submission.decklist);
            event.formData.set('properties[Companion]', result.companion.included ? result.companion.name + ' (included)' : 'Not included');
          });
          // Every cart request (theme add, background upload, order editor) is
          // built from this form: a Standard line never carries the two-sided record.
          if (form) listen(form, 'formdata', function (event) {
            var value = twoSidedPropertyValue(currentTwoSided());
            if (value) event.formData.set('properties[Two-sided cards]', value);
            else event.formData.delete('properties[Two-sided cards]');
          });

          var incomingDeckLink = null;
          var deckRoutingFlight = null;
          var deckRoutingKey = '';
          function routeIncomingDeck() {
            var source = urlInput.value;
            if (deckRoutingFlight && deckRoutingKey === source) return deckRoutingFlight;
            deckRoutingKey = source;
            updateLinkValidationStatus('loading', F.MESSAGES.routing);
            var stillCurrent = function () { return !lifecycle.signal.aborted && currentMode() === 'link' && urlInput.value === source; };
            deckRoutingFlight = cachedDeckCheck('route', {url: source}, stillCurrent).then(function (cached) {
              return cached || secureDeckRequest(function (token, signal) {
                return fetch(WORKER_URL + '?type=deck-validation&action=route', {
                  method: 'POST', headers: {'Content-Type': 'application/json', 'CF-Turnstile-Response': token},
                  body: JSON.stringify({url: source}), signal: signal
                }).then(readDeckResponse);
              }, stillCurrent);
            }).then(function (result) {
              if (!stillCurrent()) throw new Error('Deck changed. Please try again.');
              var config = root.querySelector('[data-deck-link-products]');
              var products = config ? JSON.parse(config.textContent) : {};
              var target = products[result.kind];
              if (!target) throw new Error('The matching product is unavailable. Please contact us.');
              var next = window.TRCDeckLinks.destination(window.location.href, target, result);
              updateLinkValidationStatus('loading', 'Opening your ' + result.mainboardCount + (result.sideboardCount ? ' + ' + result.sideboardCount : '') + ' card deck…', true);
              window.location.replace(next);
              var redirect = new Error('Opening the matching product…');
              redirect.redirecting = true;
              throw redirect;
            }).catch(function (error) {
              if (deckRoutingKey === source) deckRoutingFlight = null;
              throw error;
            });
            return deckRoutingFlight;
          }

          function requestDeckValidation(mode, bypassPreviewCache, previewOnlyRetry) {
            var cacheKey = profilePreviewCacheKey(mode);
            if (!bypassPreviewCache && profilePreviewCache[cacheKey]) return Promise.resolve(profilePreviewCache[cacheKey]);
            var body = {variantId: selectedVariantId(), artStyle: selectedArtStyle(mode), previewArtStyles: ['Fancy Art', 'Basic Art', 'Your Exact Printings']};
            if (mode === 'text') body.decklist = textarea.value;
            if (mode === 'link') {
              body.url = canonicalDeckUrl(urlInput.value) || urlInput.value;
              if (companionPanel) { body.companionPrompt = true; body.prepareCompanionChoices = true; }
              if (companionPanel && companionChoice() !== undefined) body.includeCompanion = companionChoice();
              body.contents = sideboardCheck ? sideboardCheck.value : 'Mainboard';
              if (bypassPreviewCache && !previewOnlyRetry) body.refreshDeck = true;
            }
            var stillCurrent = function () { return !lifecycle.signal.aborted && cacheKey === profilePreviewCacheKey(mode); };
            var fullCheck = function () {
              return secureDeckRequest(function (token, signal) {
                return fetch(WORKER_URL + '?type=deck-validation&action=' + encodeURIComponent(mode), {
                  method: 'POST', headers: {'Content-Type': 'application/json', 'CF-Turnstile-Response': token}, body: JSON.stringify(body), signal: signal
                }).then(readDeckResponse);
              }, stillCurrent);
            };
            // A deck link asks the Worker's cache first; only a deck it has
            // not read needs the security check. Refresh always reads the deck.
            var validationRequest = mode === 'link' && incomingDeckLink && incomingDeckLink.auto ? routeIncomingDeck()
              : mode === 'link' && !body.refreshDeck ? cachedDeckCheck('link', body, stillCurrent).then(function (cached) { return cached || fullCheck(); })
              : fullCheck();
            var cachedRequest = validationRequest.then(function (data) {
              if (profilePreviewCache[cacheKey] === cachedRequest) profilePreviewCache[cacheKey] = data;
              return data;
            }).catch(function (error) {
              if (profilePreviewCache[cacheKey] === cachedRequest) delete profilePreviewCache[cacheKey];
              throw error;
            });
            profilePreviewCache[cacheKey] = cachedRequest;
            return cachedRequest;
          }

          function updateTextValidationStatus(state, message) {
            if (!textValidationStatus) return;
            textValidationStatus.hidden = !state;
            textValidationStatus.className = 'deck-input__link-validation' + (state ? ' is-' + state : '');
            textValidationStatus.textContent = message || '';
            if (textValidationRetry) textValidationRetry.hidden = true;
          }

          function updateTextValidationRetry() {
            if (!textValidationRetry) return;
            var error = deckValidationErrorKey.text === profilePreviewCacheKey('text') && deckValidationError.text;
            textValidationRetry.hidden = !error || (error.validation && error.validation.retryable === false) || error.status === 422 || error.status === 400;
            textValidationRetry.disabled = !!deckTokenWaiters || Date.now() < deckValidationErrorUntil.text;
          }

          if (textValidationRetry) listen(textValidationRetry, 'click', function () {
            if (currentMode() !== 'text' || textValidationRetry.disabled) return;
            clearDeckValidation('text');
            textarea.setCustomValidity('');
            validate();
            scheduleProfilePreview('text');
          });

          function clearLinkCheckWatchdog() {
            if (linkCheckSlowTimer) window.clearTimeout(linkCheckSlowTimer);
            if (linkCheckLimitTimer) window.clearTimeout(linkCheckLimitTimer);
            linkCheckSlowTimer = null;
            linkCheckLimitTimer = null;
            var wasStalled = linkCheckStalled;
            linkCheckArmed = false;
            linkCheckStalled = false;
            if (wasStalled) updateDeckRefreshButton();
          }

          // A check that is still loading after LINK_CHECK_SLOW_MS: stop the
          // spinner and let Refresh start over. If nothing is running any more
          // (a superseded or lost response), say so at once.
          function linkCheckSlow() {
            linkCheckSlowTimer = null;
            if (!linkCheckArmed || lifecycle.signal.aborted || currentMode() !== 'link') return;
            if (!deckRequestTickets.length) { failLinkCheck(); return; }
            linkCheckStalled = true;
            showLinkCheckProgress();
            updateDeckRefreshButton();
          }

          // Past the 65 s request timeout, so a running request always ends
          // (and is answered) before the watchdog would give up on it.
          var LINK_CHECK_REQUEST_GRACE_MS = 66000;
          function linkCheckLimit() {
            linkCheckLimitTimer = null;
            if (!linkCheckArmed || lifecycle.signal.aborted || currentMode() !== 'link') return;
            // Never pull a security check away while someone is completing it;
            // waitForDeckToken bounds that wait (deckTokenWaiters drops to 0).
            if (deckChallengeInteractive && deckTokenWaiters > 0) { linkCheckLimitTimer = window.setTimeout(linkCheckLimit, 5000); return; }
            // The limit covers waiting (queue and security check), never the
            // Worker request itself: give a running request its full timeout.
            var requestStartedAt = 0;
            deckRequestTickets.forEach(function (ticket) {
              if (!ticket.cancelled && ticket.requestStartedAt > requestStartedAt) requestStartedAt = ticket.requestStartedAt;
            });
            var requestEndsIn = requestStartedAt ? requestStartedAt + LINK_CHECK_REQUEST_GRACE_MS - Date.now() : 0;
            if (requestEndsIn > 0) { linkCheckLimitTimer = window.setTimeout(linkCheckLimit, requestEndsIn); return; }
            failLinkCheck();
          }

          // A solved challenge starts the waiting limit over from that moment.
          function restartLinkCheckLimit() {
            if (!linkCheckArmed) return;
            if (linkCheckLimitTimer) window.clearTimeout(linkCheckLimitTimer);
            linkCheckLimitTimer = window.setTimeout(linkCheckLimit, LINK_CHECK_LIMIT_MS);
          }

          function failLinkCheck() {
            var security = deckTokenWaiters > 0;
            var message = security
              ? 'The security check did not finish. Press Refresh to try again. If it keeps happening, reload the page or allow this site in your content blocker.'
              : F.MESSAGES.linkCheckFailed;
            clearLinkCheckWatchdog();
            cancelDeckRequests(message);
            var key = profilePreviewCacheKey('link');
            var pending = profilePreviewCache[key];
            if (pending && typeof pending.then === 'function') delete profilePreviewCache[key];
            if (deckRefreshBusy) { deckRefreshPending = false; deckRefreshBusy = false; }
            var error = new Error(message);
            error.retryAfterSeconds = 5;
            recordDeckError('link', error, key);
            updateDeckRefreshButton();
          }

          function showLinkCheckProgress() {
            if (!linkValidationStatus || !linkCheckArmed || currentMode() !== 'link') return;
            if (deckChallengeInteractive) {
              linkValidationStatus.className = 'deck-input__link-validation is-waiting';
              linkValidationStatus.textContent = 'Please complete the security check to continue.';
            } else if (linkCheckStalled) {
              linkValidationStatus.className = 'deck-input__link-validation is-waiting';
              linkValidationStatus.textContent = deckTokenWaiters > 0
                ? 'The security check is taking longer than usual. You can wait or press Refresh to try again.'
                : 'Still checking. This can take up to a minute. You can wait or press Refresh to try again.';
            } else {
              linkValidationStatus.className = 'deck-input__link-validation is-loading';
              linkValidationStatus.textContent = linkCheckMessage;
            }
          }

          // noWatchdog: a loading line that is not a deck check (a companion
          // choice, or the page opening the matching product).
          function updateLinkValidationStatus(state, detail, noWatchdog) {
            if (!linkValidationStatus) return;
            clearLinkCheckWatchdog();
            linkValidationStatus.className = 'deck-input__link-validation';
            if (!state) {
              linkValidationStatus.hidden = true;
              linkValidationStatus.textContent = '';
              return;
            }
            linkValidationStatus.hidden = false;
            linkValidationStatus.classList.add('is-' + state);
            if (state === 'loading') {
              linkValidationStatus.textContent = detail || F.MESSAGES.checkingLink;
              if (!noWatchdog) {
                linkCheckArmed = true;
                linkCheckMessage = linkValidationStatus.textContent;
                linkCheckSlowTimer = window.setTimeout(linkCheckSlow, LINK_CHECK_SLOW_MS);
                linkCheckLimitTimer = window.setTimeout(linkCheckLimit, LINK_CHECK_LIMIT_MS);
                if (deckChallengeInteractive) showLinkCheckProgress();
              }
              return;
            }
            var data = detail || {};
            var total = Number(data.count);
            var maximum = Number(data.maximumCount || TARGET);
            var countLabel = Number.isFinite(total) ? F.countLabel(total, maximum, exactConfig) : '';
            if (state === 'valid') {
              var shortBy = underCountMessage(total);
              linkValidationStatus.textContent = countLabel + (countLabel ? ' · ' : '') + 'Deck is accessible' + (shortBy ? '. ' + shortBy : '');
              return;
            }
            // The Worker's count errors already say "This deck has N cards."
            if (/^This deck has /.test(String(data.error || ''))) countLabel = '';
            linkValidationStatus.textContent = countLabel + (countLabel ? ' · ' : '') + (data.error || 'Deck validation failed');
          }

          function canRefreshDeck(mode) {
            return mode === 'link' ? validDeckUrl(urlInput.value)
              : mode === 'text' ? !!textarea.value.trim()
              : mode === 'xml';
          }

          function updateDeckRefreshButton() {
            if (!deckLinkRefresh) return;
            var mode = currentMode();
            var key = profilePreviewCacheKey(mode);
            var attempted = deckValidationResultKey[mode] === key || deckValidationErrorKey[mode] === key || securityError;
            // Refresh belongs to the URL input, even when another tab finishes validation.
            if (deckRefreshHome && deckLinkRefresh.parentNode !== deckRefreshHome) {
              deckRefreshHome.insertBefore(deckLinkRefresh, deckRefreshNext);
            }
            // A stalled check (see linkCheckSlow) can always be started over.
            // Never while a visible challenge is being solved: Refresh would remove it.
            var stalled = linkCheckStalled && mode === 'link' && !deckChallengeInteractive;
            deckLinkRefresh.hidden = mode !== 'link' || (!IS_CREATOR_DECK && !attempted && !deckRefreshBusy && !stalled);
            deckLinkRefresh.disabled = (!stalled && (!!deckTokenWaiters || deckRefreshBusy)) || Date.now() < refreshWaitUntil(mode, key, stalled) || !canRefreshDeck(mode);
            deckLinkRefresh.textContent = deckRefreshBusy && !stalled ? 'Refreshing…' : 'Refresh';
          }

          // Refresh after a finished result reads the deck again (refreshDeck) and
          // then waits 30 s. Refresh on a stalled or unfinished check only starts
          // it over: cache first, then the normal check that joins a read already
          // in progress. That adds no deck site reads, so it skips the 30 s wait.
          // Only an answer from the Worker finishes a check: a network failure or
          // the status watchdog giving up (no HTTP status) is restarted, not re-read.
          function deckCheckFinished(mode, key) {
            return deckValidationResultKey[mode] === key ||
              (deckValidationErrorKey[mode] === key && !!deckValidationError[mode] && deckValidationError[mode].status != null && !deckValidationError[mode].turnstile);
          }
          function refreshWaitUntil(mode, key, stalled) {
            var restart = stalled || !deckCheckFinished(mode, key);
            return Math.max(restart ? 0 : deckRefreshCooldownUntil, deckValidationErrorUntil[mode] || 0);
          }
          var deckRefreshForced = true;
          function finishDeckRefresh() {
            deckRefreshPending = false;
            deckRefreshBusy = false;
            updateDeckRefreshButton();
          }

          function performDeckRefresh() {
            if (!deckRefreshPending) return;
            deckRefreshPending = false;
            var mode = currentMode();
            if (mode !== 'link') {
              finishDeckRefresh();
              validate();
              return;
            }
            var cacheKey = profilePreviewCacheKey(mode);
            var requestId = ++profilePreviewRequest;
            var run = deckRefreshRun;
            if (mode === 'link') updateLinkValidationStatus('loading', F.MESSAGES.refreshing);
            // Finish first so the rendered result can schedule its own
            // follow-up work (such as a pending printings recheck). A refresh
            // that a newer Refresh cancelled must not end the newer one.
            requestDeckValidation(mode, true, !deckRefreshForced).then(function (result) {
              if (run === deckRefreshRun) finishDeckRefresh();
              if (requestId === profilePreviewRequest && currentMode() === mode) applyDeckValidationResult(mode, result, cacheKey);
            }).catch(function (error) {
              if (run === deckRefreshRun) finishDeckRefresh();
              if (requestId === profilePreviewRequest && currentMode() === mode) recordDeckError(mode, error, cacheKey);
            });
          }

          function requestDeckRefresh() {
            var mode = currentMode();
            var stalled = linkCheckStalled && !deckChallengeInteractive;
            var restartKey = profilePreviewCacheKey(mode);
            if (mode !== 'link' || !deckLinkRefresh || (!stalled && (deckTokenWaiters || deckRefreshBusy)) || Date.now() < refreshWaitUntil(mode, restartKey, stalled) || !canRefreshDeck(mode)) return;
            deckRefreshForced = !stalled && deckCheckFinished(mode, restartKey);
            // Start over: a stalled check (or one still queued) must not hold
            // the new one behind it.
            deckRefreshRun++;
            cancelDeckRequests('Deck check restarted.');
            var key = profilePreviewCacheKey(mode);
            if (mode === 'link' && companionPanel) {
              var prefix = key.slice(0, key.lastIndexOf('\n') + 1);
              delete profilePreviewCache[prefix + 'true'];
              delete profilePreviewCache[prefix + 'false'];
            }
            if (profilePreviewTimer) window.clearTimeout(profilePreviewTimer);
            // A manual Refresh starts the automatic printings rechecks over.
            var refreshRecovery = profilePreviewRecovery[key];
            if (refreshRecovery) {
              [refreshRecovery.printingsTimer, refreshRecovery.printingsWake].forEach(function (timer) { if (timer) window.clearTimeout(timer); });
              refreshRecovery.printingsTimer = null;
              refreshRecovery.printingsWake = null;
              refreshRecovery.printingsAttempts = 0;
              refreshRecovery.printingsRetryAfter = 0;
            }
            clearDeckValidation(mode);
            delete profilePreviewCache[key];
            securityError = '';
            securityStartedAt = Date.now();
            deckRefreshBusy = true;
            deckRefreshPending = true;
            if (deckRefreshForced) {
              deckRefreshCooldownUntil = Date.now() + 30000;
              if (deckRefreshCooldownTimer) window.clearTimeout(deckRefreshCooldownTimer);
              deckRefreshCooldownTimer = window.setTimeout(updateDeckRefreshButton, 30100);
            }
            updateDeckRefreshButton();
            if (!turnstileToken) resetDeckValidationChallenge(true);
            performDeckRefresh();
          }

          function previewForArtStyle(result, artStyle) {
            if (!result || !artStyle) return null;
            if (result.previews && result.previews[artStyle]) return result.previews[artStyle];
            if (result.preview && result.preview.profileName === artStyle) return result.preview;
            return null;
          }

          // Warm the first rows of each art style so switching styles shows art
          // at once. Only a few load at a time, after the shown grid has had a
          // head start, and never every card of every style: firing hundreds of
          // images at once queued the shown grid behind them (browsers deliver
          // same-priority images one after another), so the preview took minutes.

          function cancelProfileImagePreloads() {
            if (profilePreloadTimer) window.clearTimeout(profilePreloadTimer);
            profilePreloadTimer = null;
            profilePreloadSource = null;
            profilePreloadQueue.forEach(function (url) { delete profileImageCache[url]; });
            profilePreloadQueue = [];
            profilePreloadActive.forEach(function (preload) {
              preload.onload = preload.onerror = null;
              delete profileImageCache[preload.trcUrl];
              // Clearing src stops the download in every current browser.
              try { preload.removeAttribute('src'); } catch (ignore) {}
            });
            profilePreloadActive = [];
          }

          function pumpProfileImagePreloads() {
            profilePreloadTimer = null;
            while (!lifecycle.signal.aborted && profilePreloadActive.length < PROFILE_PRELOAD_CONCURRENCY && profilePreloadQueue.length) {
              (function (url) {
                var preload = new Image();
                var done = function () {
                  preload.onload = preload.onerror = null;
                  var index = profilePreloadActive.indexOf(preload);
                  if (index === -1) return;
                  profilePreloadActive.splice(index, 1);
                  pumpProfileImagePreloads();
                };
                preload.trcUrl = url;
                preload.decoding = 'async';
                preload.onload = done;
                preload.onerror = done;
                profilePreloadActive.push(preload);
                profileImageCache[url] = preload;
                preload.src = url;
              })(profilePreloadQueue.shift());
            }
          }

          function preloadProfileImages(mode, result) {
            // The same response applied again (after the security widget
            // resets, or a tab switch back) keeps its preloads running.
            if (result && result === profilePreloadSource) return;
            cancelProfileImagePreloads();
            if (!result || !result.previews) return;
            profilePreloadSource = result;
            // The selected style's own grid loads its tiles (lazily, as they come
            // into view), so it is never preloaded twice.
            var shown = selectedArtStyle(mode);
            Object.keys(result.previews).forEach(function (style) {
              if (style === shown) return;
              var preview = result.previews[style];
              (preview && preview.cards || []).filter(function (card) { return card && card.face !== 'back'; })
                .slice(0, PROFILE_PRELOAD_PER_STYLE).forEach(function (card) {
                  var url = card.thumbnailUrl;
                  if (!url || profileImageCache[url]) return;
                  profileImageCache[url] = true;
                  profilePreloadQueue.push(url);
                });
            });
            if (profilePreloadQueue.length) profilePreloadTimer = window.setTimeout(pumpProfileImagePreloads, PROFILE_PRELOAD_DELAY_MS);
          }

          function applyProfilePreviewFields(mode, preview) {
            if (currentMode() !== mode) return;
            var storedProfile = preview && preview.profileId ? preview : null;
            var values = [
              [previewProfileField, storedProfile && storedProfile.profileId],
              [previewRevisionField, storedProfile && storedProfile.profileRevision],
              [previewSnapshotField, storedProfile && storedProfile.snapshotId],
            ];
            values.forEach(function (pair) {
              var field = pair[0], value = pair[1];
              if (!field) return;
              field.value = value === undefined || value === null ? '' : String(value);
              field.disabled = !field.value;
            });
          }

          function clearProfilePreviewDisclosure(container) {
            if (!container || !container._trcProfilePreviewCleanup) return;
            container._trcProfilePreviewCleanup();
            container._trcProfilePreviewCleanup = null;
          }

          function syncProfilePreviewDisclosure(viewport, grid, toggle) {
            var cards = Array.prototype.slice.call(grid.children);
            var gridRect = grid.getBoundingClientRect();
            var rows = [];
            cards.forEach(function (card) {
              var rect = card.getBoundingClientRect();
              if (!rect.height) return;
              var row = rows.find(function (existing) {
                return Math.abs(existing.top - rect.top) < 2;
              });
              if (!row) rows.push({ top: rect.top, height: rect.height });
            });
            rows.sort(function (a, b) { return a.top - b.top; });

            var isCollapsible = rows.length > 3;
            viewport.classList.toggle('is-collapsible', isCollapsible);
            toggle.hidden = !isCollapsible;
            if (!isCollapsible) {
              viewport.classList.remove('is-expanded');
              viewport.style.removeProperty('--trc-profile-collapsed-height');
              viewport.style.removeProperty('--trc-profile-fade-height');
              updateProfilePreviewToggle(toggle, false);
              return;
            }

            var fourthRow = rows[3];
            var collapsedHeight = fourthRow.top - gridRect.top + (fourthRow.height / 2);
            viewport.style.setProperty('--trc-profile-collapsed-height', Math.ceil(collapsedHeight) + 'px');
            viewport.style.setProperty('--trc-profile-fade-height', Math.ceil(fourthRow.height / 2) + 'px');
          }

          function updateProfilePreviewToggle(toggle, expanded) {
            var label = toggle.querySelector('.deck-input__profile-toggle-label');
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (label) label.textContent = expanded ? 'Show less' : 'Show more';
          }

          function setupProfilePreviewDisclosure(container, viewport, grid, toggle) {
            clearProfilePreviewDisclosure(container);
            var sync = function () { syncProfilePreviewDisclosure(viewport, grid, toggle); };
            var resizeObserver = null;
            var fallbackResize = null;

            viewport.classList.toggle('is-expanded', profilePreviewExpanded);
            updateProfilePreviewToggle(toggle, profilePreviewExpanded);
            toggle.addEventListener('click', function () {
              if (!viewport.classList.contains('is-expanded')) {
                profilePreviewExpanded = true;
                viewport.classList.add('is-expanded');
                updateProfilePreviewToggle(toggle, true);
                return;
              }

              var scrollTopBefore = window.scrollY;
              var expandedHeight = viewport.getBoundingClientRect().height;
              var documentElement = document.documentElement;
              var previousOverflowAnchor = documentElement.style.overflowAnchor;
              documentElement.style.overflowAnchor = 'none';
              profilePreviewExpanded = false;
              viewport.classList.remove('is-expanded');
              updateProfilePreviewToggle(toggle, false);
              var collapsedHeight = viewport.getBoundingClientRect().height;
              var removedHeight = Math.max(0, expandedHeight - collapsedHeight);
              var targetScrollTop = Math.max(0, scrollTopBefore - removedHeight);
              var targetScrollLeft = window.scrollX;

              function restoreCollapsedScrollPosition() {
                window.scrollTo({
                  top: targetScrollTop,
                  left: targetScrollLeft,
                  behavior: 'instant'
                });
              }

              restoreCollapsedScrollPosition();
              window.requestAnimationFrame(function () {
                restoreCollapsedScrollPosition();
                window.requestAnimationFrame(function () {
                  restoreCollapsedScrollPosition();
                  documentElement.style.overflowAnchor = previousOverflowAnchor;
                });
              });
            });

            if (window.ResizeObserver) {
              resizeObserver = new ResizeObserver(sync);
              resizeObserver.observe(grid);
            } else {
              fallbackResize = sync;
              listen(window, 'resize', fallbackResize);
            }
            container._trcProfilePreviewCleanup = function () {
              if (resizeObserver) resizeObserver.disconnect();
              if (fallbackResize) window.removeEventListener('resize', fallbackResize);
            };
            sync();
          }

          // The flip glyph (two curved arrows in a loop) of the cart and tracker deck popups.
          var PROFILE_FLIP_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 11a8 8 0 0 0-14.5-4.6L4 8"/><path d="M4 3v5h5"/><path d="M4 13a8 8 0 0 0 14.5 4.6L20 16"/><path d="M20 21v-5h-5"/></svg>';

          // One preview tile ({card, back}). A double-faced card flips in place: the image and its alt change, the
          // back face never wears the foil sheen (is-back) and carries the "Not foil" tag (CSS shows it on foil only).
          // A Scryfall WebP image a browser cannot show (Safari on macOS 10.15 and older): the face's /normal/ JPEG.
          function scryfallJpeg(url) {
            var webp = /^https:\/\/cards\.scryfall\.io\/(?:thumb|grid|display|crop|art)\/((?:front|back)\/[0-9a-f]\/[0-9a-f]\/[0-9a-f-]{36})\.webp(?:\?\d{1,12})?$/.exec(url || '');
            return webp ? 'https://cards.scryfall.io/normal/' + webp[1] + '.jpg' : '';
          }

          function profilePreviewTile(entry) {
            var card = entry.card;
            var showBack = false;
            var jpegOnly = false;
            var flip = null;
            var noFoil = null;
            var tile = document.createElement('div');
            tile.className = 'deck-input__profile-card';
            tile.title = card.name + (card.quantity > 1 ? ' ×' + card.quantity : '');
            var image = document.createElement('img');
            // Only the tiles near the screen load; the rest wait until the grid
            // is expanded or scrolled to (browsers without lazy loading load all).
            image.loading = 'lazy';
            image.decoding = 'async';
            tile.appendChild(image);
            function showFace() {
              var face = showBack ? entry.back : card;
              tile.classList.toggle('is-fancy-fallback', face.fallbackType === 'fancy-profile');
              tile.classList.toggle('is-back', showBack);
              if (showBack) tile.dataset.side = 'back';
              else delete tile.dataset.side;
              image.src = (jpegOnly && scryfallJpeg(face.thumbnailUrl)) || face.thumbnailUrl;
              image.alt = showBack ? 'Back of ' + card.name : card.name;
              if (showBack && !noFoil) {
                noFoil = document.createElement('span');
                noFoil.className = 'deck-input__profile-noFoil';
                noFoil.textContent = 'Not foil';
                tile.insertBefore(noFoil, image.nextSibling);
              } else if (!showBack && noFoil) {
                noFoil.remove();
                noFoil = null;
              }
              if (flip) flip.setAttribute('aria-pressed', String(showBack));
            }
            image.addEventListener('error', function () {
              // Its /normal/ JPEG, once; a flip then goes straight to the other face's JPEG.
              var jpeg = scryfallJpeg(image.getAttribute('src'));
              if (jpeg) { jpegOnly = true; image.src = jpeg; return; }
              if (flip) { flip.remove(); flip = null; tile.classList.remove('has-flip'); }
              // A back that cannot load: the tile goes back to its front and keeps no flip.
              if (showBack) { showBack = false; showFace(); return; }
              image.hidden = true;
              var unavailable = document.createElement('span');
              unavailable.textContent = card.name + ': preview unavailable';
              tile.appendChild(unavailable);
            });
            if (Number(card.quantity || 1) > 1) {
              var quantity = document.createElement('span');
              quantity.className = 'deck-input__profile-quantity';
              quantity.textContent = '×' + card.quantity;
              tile.appendChild(quantity);
            }
            if (entry.back) {
              flip = document.createElement('button');
              flip.type = 'button';
              flip.className = 'deck-input__profile-flip';
              tile.classList.add('has-flip');
              flip.innerHTML = PROFILE_FLIP_ICON;
              flip.setAttribute('aria-label', 'Flip ' + card.name);
              flip.addEventListener('click', function () {
                showBack = !showBack;
                showFace();
              });
              tile.appendChild(flip);
            }
            showFace();
            return tile;
          }

          // Each style's grid is kept (a few per tab) and put back as is. New tiles on
          // every switch let the browser drop a style's images once a third was shown.
          var PROFILE_GRID_KEEP = 3;
          var keptProfileGrids = { text: [], link: [] };
          function profilePreviewGrid(mode, entries, create) {
            var kept = keptProfileGrids[mode];
            var key = entries.map(function (entry) {
              var card = entry.card, back = entry.back || {};
              return [card.name, card.quantity || 1, card.thumbnailUrl, card.fallbackType, back.thumbnailUrl, back.fallbackType].join('\t');
            }).join('\n');
            for (var i = 0; kept && i < kept.length; i++) {
              if (kept[i].key !== key) continue;
              var hit = kept[i];
              if (create) { kept.splice(i, 1); kept.push(hit); }
              return hit.grid;
            }
            if (!create) return null;
            var grid = document.createElement('div');
            grid.className = 'deck-input__profile-grid';
            entries.forEach(function (entry) { grid.appendChild(profilePreviewTile(entry)); });
            if (kept && entries.length) {
              var entry = { key: key, grid: grid };
              kept.push(entry);
              if (kept.length > PROFILE_GRID_KEEP) kept.shift();
              // A tile that failed to load is not kept: the next visit retries it.
              grid.addEventListener('error', function () {
                var index = kept.indexOf(entry);
                if (index !== -1) kept.splice(index, 1);
              }, true);
            }
            return grid;
          }

          // One tile per card: a double-faced card's back (face 'back', display only, right after its front) is
          // the other side of its front's tile, shown with the flip button, never a tile of its own.
          function profilePreviewEntries(preview) {
            var visibleCards = [];
            var lastFront = null;
            (preview.cards || []).forEach(function (card) {
              if (card.face === 'back') {
                if (lastFront && !lastFront.back && card.thumbnailUrl) lastFront.back = card;
                lastFront = null;
                return;
              }
              lastFront = card.thumbnailUrl ? {card: card, back: null} : null;
              if (lastFront) visibleCards.push(lastFront);
            });
            return visibleCards;
          }

          // A kept grid swaps in once its first tiles decode, never blank.
          var PROFILE_SWAP_DECODE_TILES = 24;
          var PROFILE_SWAP_DECODE_MS = 250;
          var profileSwapRequest = 0;
          function showSelectedProfilePreview(mode, result) {
            var request = ++profileSwapRequest;
            var preview = previewForArtStyle(result, selectedArtStyle(mode));
            var container = root.querySelector('[data-profile-preview="' + mode + '"]');
            var shown = container && !container.hidden && container.querySelector('.deck-input__profile-grid');
            var grid = preview && shown ? profilePreviewGrid(mode, profilePreviewEntries(preview), false) : null;
            var images = grid && grid !== shown && typeof Promise === 'function'
              ? Array.prototype.slice.call(grid.querySelectorAll('img'), 0, PROFILE_SWAP_DECODE_TILES).filter(function (image) {
                return !image.hidden && image.complete && image.naturalWidth > 0 && typeof image.decode === 'function';
              })
              : [];
            if (!images.length) { renderSelectedProfilePreview(mode, result); return; }
            // Add to cart reads the new style at once; only the picture waits.
            profilePreviewResult[mode] = preview;
            applyProfilePreviewFields(mode, preview);
            var swapped = false;
            var swap = function () {
              if (swapped) return;
              swapped = true;
              if (request !== profileSwapRequest || lifecycle.signal.aborted || deckValidationResult[mode] !== result
                || deckValidationResultKey[mode] !== profilePreviewCacheKey(mode)) return;
              renderSelectedProfilePreview(mode, result);
            };
            window.setTimeout(swap, PROFILE_SWAP_DECODE_MS);
            Promise.all(images.map(function (image) {
              try { return image.decode().catch(function () {}); } catch (ignore) { return null; }
            })).then(swap);
          }

          function renderProfilePreview(mode, preview, stateMessage, printingsRetry) {
            var container = root.querySelector('[data-profile-preview="' + mode + '"]');
            if (!container) return;
            clearProfilePreviewDisclosure(container);
            container.classList.toggle('is-loading', !!stateMessage && !preview);
            container.classList.toggle('is-exact-printings', mode === 'images' || mode === 'xml' || (!!preview && preview.profileName === 'Exact Printings'));
            if (!preview) {
              container.hidden = !stateMessage;
              container.textContent = stateMessage || '';
              applyProfilePreviewFields(mode, null);
              return;
            }
            var content = document.createDocumentFragment();
            var head = document.createElement('div');
            head.className = 'deck-input__profile-preview-head';
            var title = document.createElement('p');
            title.className = 'deck-input__profile-preview-title';
            title.textContent = preview.profileName + ' deck preview';
            head.appendChild(title);
            content.appendChild(head);
            var visibleCards = profilePreviewEntries(preview);
            var grid = profilePreviewGrid(mode, visibleCards, true);
            var viewport = null;
            var toggle = null;
            if (visibleCards.length) {
              viewport = document.createElement('div');
              viewport.className = 'deck-input__profile-grid-viewport';
              viewport.id = deckInputConfig.PROFILE_PREVIEW_GRID_ID_PREFIX + mode;
              viewport.appendChild(grid);
              content.appendChild(viewport);

              toggle = document.createElement('button');
              toggle.type = 'button';
              toggle.className = 'deck-input__profile-toggle';
              toggle.setAttribute('aria-expanded', 'false');
              toggle.setAttribute('aria-controls', viewport.id);
              toggle.hidden = true;
              var toggleLabel = document.createElement('span');
              toggleLabel.className = 'deck-input__profile-toggle-label';
              toggleLabel.textContent = 'Show more';
              toggle.appendChild(toggleLabel);
              var toggleArrows = document.createElement('span');
              toggleArrows.className = 'deck-input__profile-toggle-arrows';
              toggleArrows.setAttribute('aria-hidden', 'true');
              toggleArrows.appendChild(document.createElement('span'));
              toggleArrows.appendChild(document.createElement('span'));
              toggle.appendChild(toggleArrows);
              content.appendChild(toggle);
            }
            // The notes under the grid: the Fireball Foil line first (syncTwoSidedNotice fills it), then the art style notes.
            var foilNote = document.createElement('div');
            foilNote.className = 'deck-input__profile-warning deck-input__foil-note';
            foilNote.setAttribute('data-foil-note', '');
            foilNote.hidden = true;
            content.appendChild(foilNote);
            var note = document.createElement('div');
            var isExactPreview = preview.profileName === 'Exact Printings';
            note.className = 'deck-input__profile-warning';
            if (!isExactPreview && preview.missingCount) {
              var noteCopy = document.createElement('p');
              noteCopy.textContent = 'Some cards don’t have saved ' + preview.profileName + ' yet. We choose those printings before we print.';
              note.appendChild(noteCopy);
            }
            if (isExactPreview && Array.isArray(preview.fancyFallbackCards) && preview.fancyFallbackCards.length) {
              var fallbackCopy = document.createElement('p');
              // A creator deck's printings are the creator's picks; a custom deck's are the customer's.
              fallbackCopy.textContent = IS_CREATOR_DECK
                ? 'Some of the creator’s printings don’t have a usable image, so we’ll print these cards with our Fancy Art instead:'
                : 'These cards don’t have a usable image for the printing you picked, so we’ll print them with our Fancy Art:';
              note.appendChild(fallbackCopy);
              // Every name on its own indented line, however many there are.
              var fallbackList = document.createElement('ul');
              preview.fancyFallbackCards.forEach(function (card) {
                var item = document.createElement('li');
                item.textContent = card.name + (Number(card.quantity || 1) > 1 ? ' ×' + card.quantity : '');
                fallbackList.appendChild(item);
              });
              note.appendChild(fallbackList);
            }
            var printingsRetryButton = null;
            if (isExactPreview && preview.pendingCount) {
              var pendingCopy = document.createElement('p');
              var pendingTotal = Number(preview.pendingCount) || 0;
              if (printingsRetry && printingsRetry.checking) {
                // An automatic recheck is scheduled or running; keep the partial grid and say so.
                pendingCopy.textContent = 'We couldn’t confirm ' + pendingTotal + (pendingTotal === 1 ? ' printing' : ' printings') + ' yet. Checking again in a moment.';
              } else {
                // The Retry printings button, when shown, is the action; otherwise one short sentence says what to do.
                pendingCopy.textContent = 'We couldn’t check some printings just now. Your picks are saved.'
                  + (printingsRetry ? '' : mode === 'link' ? ' Use Refresh to try again.' : ' Edit your list or try again in a moment.');
                if (printingsRetry) {
                  printingsRetryButton = document.createElement('button');
                  printingsRetryButton.type = 'button';
                  printingsRetryButton.className = 'deck-input__profile-toggle';
                  printingsRetryButton.textContent = 'Retry printings';
                  printingsRetryButton.disabled = !!printingsRetry.disabled;
                  printingsRetryButton.addEventListener('click', printingsRetry.retry);
                }
              }
              note.appendChild(pendingCopy);
              if (printingsRetryButton) note.appendChild(printingsRetryButton);
            }
            if (note.childNodes.length) content.appendChild(note);
            container.replaceChildren(content);
            container.hidden = false;
            if (viewport && toggle) setupProfilePreviewDisclosure(container, viewport, grid, toggle);
            profilePreviewResult[mode] = preview;
            applyProfilePreviewFields(mode, preview);
            syncTwoSidedNotice();
          }

          function renderSelectedProfilePreview(mode, result, stateMessage) {
            var artStyle = selectedArtStyle(mode);
            if (!artStyle) {
              clearProfilePreview(mode);
              return;
            }
            var preview = previewForArtStyle(result, artStyle);
            if (preview || !result || stateMessage) {
              renderProfilePreview(mode, preview, stateMessage, stateMessage ? null : pendingPrintingsRetry(mode, result, preview));
              return;
            }
            // Missing profile data means the lookup failed, not that Studio is
            // still generating art. Do not keep a variant's partial response
            // permanently stuck while another finish has a successful preview.
            var cacheKey = profilePreviewCacheKey(mode);
            var recovery = profilePreviewRecovery[cacheKey] || (profilePreviewRecovery[cacheKey] = {});
            if (!recovery.attempted && !recovery.timer) {
              recovery.timer = window.setTimeout(function () {
                recovery.timer = null;
                retryProfilePreview(mode, cacheKey);
              }, 1000);
            }
            var loading = (!recovery.attempted && !!recovery.timer) || recovery.pending;
            renderProfilePreview(mode, null, loading ? 'Retrying art preview…' : 'Art preview is temporarily unavailable.');
            var container = root.querySelector('[data-profile-preview="' + mode + '"]');
            container.classList.toggle('is-loading', !!loading);
            if (!loading) {
              var retry = document.createElement('button');
              retry.type = 'button';
              retry.className = 'deck-input__profile-toggle';
              retry.textContent = 'Retry preview';
              retry.disabled = Date.now() < (recovery.retryAfter || 0);
              retry.addEventListener('click', function () { retryProfilePreview(mode, cacheKey); });
              container.appendChild(retry);
            }
          }

          // A 200 can still carry Exact Printings the Worker could not confirm
          // yet (its Scryfall lookup timed out or was rate limited). Recheck
          // them in the background a bounded number of times through the same
          // preview-only retry, which reuses the provider's cached deck.
          var PRINTINGS_AUTO_RETRIES = 2;
          function pendingPrintingsCount(preview) {
            return preview && preview.profileName === 'Exact Printings' ? Number(preview.pendingCount) || 0 : 0;
          }

          function printingsRetryDelay(preview, attempt) {
            var seconds = Math.min(60, Math.max(5, Math.round(Number(preview && preview.retryAfterSeconds)) || 5));
            return (attempt ? Math.max(seconds, 15) : seconds) * 1000;
          }

          function printingsRetryIsCurrent(mode, cacheKey) {
            return !lifecycle.signal.aborted && currentMode() === mode && cacheKey === profilePreviewCacheKey(mode);
          }

          function pendingPrintingsRetry(mode, result, preview) {
            if ((mode !== 'link' && mode !== 'text') || !pendingPrintingsCount(preview) || lifecycle.signal.aborted) return null;
            var cacheKey = profilePreviewCacheKey(mode);
            if (!result || deckValidationResult[mode] !== result || deckValidationResultKey[mode] !== cacheKey) return null;
            var recovery = profilePreviewRecovery[cacheKey] || (profilePreviewRecovery[cacheKey] = {});
            var attempts = recovery.printingsAttempts || 0;
            if (!recovery.pending && !recovery.printingsTimer && attempts < PRINTINGS_AUTO_RETRIES && !deckRefreshBusy) {
              // The delay also waits out any Retry-After from a failed attempt.
              recovery.printingsTimer = window.setTimeout(function () {
                recovery.printingsTimer = null;
                retryProfilePreview(mode, cacheKey, 'auto');
              }, Math.max(printingsRetryDelay(preview, attempts), (recovery.retryAfter || 0) - Date.now()));
            }
            var checking = !!recovery.printingsTimer || (!!recovery.pending && recovery.printingsRetry === 'auto');
            var readyAt = Math.max(recovery.retryAfter || 0, recovery.printingsRetryAfter || 0);
            if (!checking && !recovery.pending && Date.now() < readyAt && !recovery.printingsWake) {
              recovery.printingsWake = window.setTimeout(function () {
                recovery.printingsWake = null;
                if (printingsRetryIsCurrent(mode, cacheKey) && deckValidationResult[mode]) renderSelectedProfilePreview(mode, deckValidationResult[mode]);
              }, readyAt - Date.now() + 100);
            }
            return {
              checking: checking,
              disabled: !!recovery.pending || Date.now() < readyAt,
              retry: function () { retryProfilePreview(mode, cacheKey, 'manual'); }
            };
          }

          function retryProfilePreview(mode, cacheKey, printings) {
            if (lifecycle.signal.aborted || currentMode() !== mode || profilePreviewCacheKey(mode) !== cacheKey) return;
            var recovery = profilePreviewRecovery[cacheKey];
            var result = deckValidationResult[mode];
            if (!recovery || recovery.pending || !result) return;
            var artStyle = selectedArtStyle(mode);
            if (printings) {
              // Only the selected Exact Printings preview with unconfirmed rows is
              // rechecked. The automatic timer already waited out Retry-After.
              if (deckRefreshBusy || deckValidationResultKey[mode] !== cacheKey || !pendingPrintingsCount(previewForArtStyle(result, artStyle))) return;
              if (printings === 'auto') {
                if ((recovery.printingsAttempts || 0) >= PRINTINGS_AUTO_RETRIES) return;
                recovery.printingsAttempts = (recovery.printingsAttempts || 0) + 1;
              } else if (Date.now() < Math.max(recovery.retryAfter || 0, recovery.printingsRetryAfter || 0)) return;
            } else {
              if (Date.now() < (recovery.retryAfter || 0) || previewForArtStyle(result, artStyle)) return;
              recovery.attempted = true;
            }
            recovery.pending = true;
            recovery.printingsRetry = printings || '';
            var requestId = ++profilePreviewRequest;
            renderSelectedProfilePreview(mode, result);
            // A superseded printings retry must not leave its status line behind.
            var rerenderIfCurrent = function () {
              if (printings && printingsRetryIsCurrent(mode, cacheKey) && deckValidationResult[mode] && deckValidationResultKey[mode] === cacheKey) {
                renderSelectedProfilePreview(mode, deckValidationResult[mode]);
              }
            };
            // Reuse the provider's cached deck and preserve a valid checkout /
            // custom-back proof while retrying this optional enrichment.
            requestDeckValidation(mode, true, true).then(function (data) {
              recovery.pending = false;
              recovery.printingsRetry = '';
              if (requestId !== profilePreviewRequest || currentMode() !== mode || cacheKey !== profilePreviewCacheKey(mode)) { rerenderIfCurrent(); return; }
              var retriedPreview = previewForArtStyle(data, artStyle);
              if (printings && pendingPrintingsCount(retriedPreview)) recovery.printingsRetryAfter = Date.now() + printingsRetryDelay(retriedPreview, 0);
              // A provider cache can expire between attempts. If the accepted
              // deck changed, its old proof (including any bound back) is stale.
              if (['count', 'decklist', 'url', 'contents', 'submission', 'cards'].some(function (key) {
                return JSON.stringify(result[key]) !== JSON.stringify(data[key]);
              })) clearDeckValidation(mode);
              applyDeckValidationResult(mode, data, cacheKey);
            }).catch(function (error) {
              recovery.pending = false;
              recovery.printingsRetry = '';
              recovery.retryAfter = Date.now() + Math.max(5, Number(error.retryAfterSeconds) || 5) * 1000;
              if (requestId !== profilePreviewRequest || currentMode() !== mode || cacheKey !== profilePreviewCacheKey(mode)) { rerenderIfCurrent(); return; }
              renderSelectedProfilePreview(mode, result);
              recovery.timer = window.setTimeout(function () {
                recovery.timer = null;
                if (!lifecycle.signal.aborted && currentMode() === mode && cacheKey === profilePreviewCacheKey(mode)) renderSelectedProfilePreview(mode, deckValidationResult[mode]);
              }, Math.max(0, recovery.retryAfter - Date.now()) + 100);
            });
          }

          function normalizeDecklistText(value) {
            return String(value || '').replace(/\r\n?/g, '\n').split('\n').map(function (line) { return line.replace(/\s+$/, ''); }).join('\n').trim();
          }

          function applyDeckValidationResult(mode, result, cacheKey) {
            if (lifecycle.signal.aborted) return false;
            if (cacheKey !== profilePreviewCacheKey(mode)) {
              // Another subscriber may already have applied this exact response
              // and canonicalized the URL while submit was waiting for it.
              return deckValidationResult[mode] === result
                && deckValidationResultKey[mode] === profilePreviewCacheKey(mode)
                && !!deckValidationTokens[mode];
            }
            if (mode === 'link') showCompanion(result.companion || null);
            var retainedProof = deckValidationKeys[mode] === cacheKey ? deckValidationTokens[mode] : '';
            if (exactQuantity) exactQuantity.adopt(result.quote);
            // The Worker, checkout Function and export all compare the whitespace-normalized
            // list, so never rewrite what the customer is typing (a just-typed new line or
            // trailing space would vanish). Adopt the Worker's text only if it differs in content.
            if (mode === 'text' && result.decklist) {
              if (normalizeDecklistText(textarea.value) !== normalizeDecklistText(result.decklist)) textarea.value = result.decklist;
              textarea.setCustomValidity('');
            }
            if (mode === 'link' && result.url) {
              urlInput.value = result.url;
              if (sideboardCheck && result.contents) sideboardCheck.value = result.contents;
              urlInput.setCustomValidity('');
            }
            var canonicalKey = profilePreviewCacheKey(mode);
            deckValidationResult[mode] = result;
            deckValidationResultKey[mode] = canonicalKey;
            profilePreviewCache[canonicalKey] = result;
            if (mode === 'link' && result.companionChoices) {
              var prefix = canonicalKey.slice(0, canonicalKey.lastIndexOf('\n') + 1);
              profilePreviewCache[prefix + 'false'] = result.companionChoices.withoutCompanion;
              profilePreviewCache[prefix + 'true'] = result.companionChoices.withCompanion;
            }
            deckValidationError[mode] = null;
            deckValidationErrorKey[mode] = '';
            deckValidationErrorUntil[mode] = 0;
            setDeckValidation(mode, retainedProof || result.validationToken || '');
            preloadProfileImages(mode, result);
            if (mode === 'text') {
              var textShortBy = underCountMessage(Number(result.count) || cardCount);
              updateTextValidationStatus('valid', 'Card names verified.' + (textShortBy ? ' ' + textShortBy : ''));
            }
            if (mode === 'link') updateLinkValidationStatus(result.requiresCompanionChoice ? 'loading' : 'valid', result.requiresCompanionChoice ? 'Companion detected. Choose whether to include it below.' : result, !!result.requiresCompanionChoice);
            if (currentMode() === mode) renderSelectedProfilePreview(mode, result);
            if (mode === 'link') updateDeckRefreshButton();
            validate();
            return true;
          }

          function recordDeckError(mode, error, cacheKey) {
            if (error && error.redirecting) return;
            if (lifecycle.signal.aborted || cacheKey !== profilePreviewCacheKey(mode)) return;
            deckValidationError[mode] = error;
            deckValidationErrorKey[mode] = cacheKey;
            deckValidationErrorUntil[mode] = Date.now() + Math.max(5, Number(error.retryAfterSeconds) || 5) * 1000;
            if (mode === 'text') updateTextValidationStatus('error', error.message || 'Card names could not be checked. Please retry.');
            if (mode === 'link') updateLinkValidationStatus('error', Object.assign({}, error.validation || {}, {error: error.message}));
            if (selectedArtStyle(mode)) renderProfilePreview(mode, null, error.message || 'Deck preview temporarily unavailable. Please retry.');
            window.setTimeout(function () { if (!lifecycle.signal.aborted) validate(); }, Math.max(0, deckValidationErrorUntil[mode] - Date.now()) + 100);
            validate();
          }

          // The typing pause is skipped for a pasted or tidied link, a deck_url
          // link and the creator page's own deck (linkCheckNow).
          var linkCheckNow = !!IS_CREATOR_DECK;
          function scheduleProfilePreview(mode, immediate) {
            if (profilePreviewTimer) window.clearTimeout(profilePreviewTimer);
            if (!lifecycle.signal.aborted && currentMode() === mode && (mode === 'images')) {
              renderProfilePreview(mode, uploadedArtPreviews[mode]);
              return;
            }
            if (lifecycle.signal.aborted || (mode !== 'text' && mode !== 'link') || currentMode() !== mode) return;
            if (mode === 'link' && !validDeckUrl(urlInput.value)) { updateLinkValidationStatus(); clearProfilePreview(mode); return; }
            if (mode === 'text' && !textarea.value.trim()) { updateTextValidationStatus(); clearProfilePreview(mode); return; }
            // D-7: a list that is wrong on its face is never sent for a card check.
            if (mode === 'text') { tally(); if (textListIssue) { updateTextValidationStatus(); clearProfilePreview(mode); return; } }
            var cacheKey = profilePreviewCacheKey(mode);
            if (deckValidationResult[mode] && deckValidationResultKey[mode] === cacheKey) {
              applyDeckValidationResult(mode, deckValidationResult[mode], cacheKey);
              return;
            }
            var prepared = profilePreviewCache[cacheKey];
            if (prepared && typeof prepared.then !== 'function' && prepared.validationToken) {
              applyDeckValidationResult(mode, prepared, cacheKey);
              return;
            }
            // Errors persist visibly until retry/input edit, but never trap the user.
            if (deckValidationErrorKey[mode] === cacheKey) { validate(); return; }
            var requestId = ++profilePreviewRequest;
            if (mode === 'text') updateTextValidationStatus('loading', F.MESSAGES.checkingNames);
            if (mode === 'link') updateLinkValidationStatus('loading', F.MESSAGES.checkingLink);
            if (selectedArtStyle(mode)) renderProfilePreview(mode, null, F.MESSAGES.preparingPreviews);
            var delay = immediate || (mode === 'link' && linkCheckNow) ? 0 : 650;
            profilePreviewTimer = window.setTimeout(function () {
              profilePreviewTimer = null;
              if (requestId !== profilePreviewRequest || currentMode() !== mode || lifecycle.signal.aborted) return;
              if (mode === 'link') linkCheckNow = false;
              // Every current subscriber attaches to a shared request. Returning to
              // a still-running deck must not depend on an obsolete callback.
              requestDeckValidation(mode).then(function (result) {
                if (requestId !== profilePreviewRequest || currentMode() !== mode) return;
                applyDeckValidationResult(mode, result, cacheKey);
              }).catch(function (error) {
                if (requestId !== profilePreviewRequest || currentMode() !== mode) return;
                recordDeckError(mode, error, cacheKey);
              });
            }, delay);
          }

          // --- Card back: element lookup + state helpers ---
          function cbEl(name, suffix) { return root.querySelector('[data-' + name + '="' + suffix + '"]'); }

          // 'uploaded' (field already holds name|url) | 'staged' (valid image, not uploaded) | 'none'
          function cardbackState(suffix) {
            var field = cbEl('cardback-field', suffix);
            if (field && /\|https?:\/\//.test(field.value)) return 'uploaded';
            return cardback[suffix] ? 'staged' : 'none';
          }

          function ratioWarning(w, h) {
            if (!w || !h) return null;
            var r = w / h;
            var off = Math.abs(r - CB_TARGET_RATIO) / CB_TARGET_RATIO;
            if (off > CB_RATIO_TOLERANCE) {
              return 'Heads up: this image is ' + w + '×' + h + ' (about ' + r.toFixed(2) +
                ':1). Card backs print best at a 5:7 ratio (~816×1110px), so yours may be cropped or stretched.';
            }
            return null;
          }

          function ensureCardbackTurnstile(suffix) {
            var verify = cbEl('cardback-verify', suffix);
            var container = cbEl('cardback-turnstile', suffix);
            if (!verify || !container || lifecycle.signal.aborted) return;
            verify.hidden = false;
            if (!window.turnstile) {
              if (Date.now() - securityStartedAt > 30000) { securityError = 'The security check could not load. Please retry.'; validate(); return; }
              // API not ready yet — retry while the image is still staged on this tab
              setTimeout(function () {
                if (cardback[suffix] && currentMode() === suffix) ensureCardbackTurnstile(suffix);
              }, 300);
              return;
            }
            if (cardbackWidgetId !== null && cardbackWidgetSuffix === suffix) return; // already here
            teardownCardbackTurnstile();
            cardbackWidgetSuffix = suffix;
            cardbackWidgetId = window.turnstile.render(container, {
              sitekey: container.getAttribute('data-sitekey'),
              action: 'trc-cardback-upload',
              callback: function (token) { if (token === cardbackSpent) return; cardbackToken = token; cardbackTokenAt = Date.now(); validate(); },
              'error-callback': function () { cardbackToken = null; validate(); },
              'expired-callback': function () { cardbackToken = null; validate(); }
            });
          }

          function resetCardbackChallenge() {
            cardbackToken = null;
            if (window.turnstile && cardbackWidgetId !== null) { try { window.turnstile.reset(cardbackWidgetId); } catch (e) {} }
          }

          // An unspent, fresh card back token: a stale one is replaced first.
          function freshCardbackToken() {
            var until = Date.now() + 30000;
            return new Promise(function (resolve, reject) {
              (function check() {
                if (cardbackToken && Date.now() - cardbackTokenAt > TOKEN_MAX_AGE_MS) { cardbackSpent = cardbackToken; resetCardbackChallenge(); }
                if (cardbackToken && cardbackToken !== cardbackSpent) { cardbackSpent = cardbackToken; return resolve(cardbackSpent); }
                if (lifecycle.signal.aborted || Date.now() > until) return reject(new Error(SECURITY_FAILED_COPY));
                window.setTimeout(check, 100);
              })();
            });
          }

          function sendCardback(file, deckToken, retried) {
            return freshCardbackToken().then(function (token) { return uploadCardback(file, token, deckToken); }).catch(function (error) {
              if (retried || !retrySecurity(error)) throw error;
              resetCardbackChallenge();
              return securityRetryWait(error).then(function () { return sendCardback(file, deckToken, true); });
            });
          }

          function teardownCardbackTurnstile() {
            if (window.turnstile && cardbackWidgetId !== null) {
              try { window.turnstile.remove(cardbackWidgetId); } catch (e) {}
            }
            cardbackWidgetId = null;
            cardbackWidgetSuffix = null;
            cardbackToken = null;
          }

          // Validate, preview, and stage (or clear) a chosen card-back image. No upload yet.
          function stageCardback(suffix, file) {
            var nameEl   = cbEl('cardback-name', suffix);
            var msgEl    = cbEl('cardback-msg', suffix);
            var preview  = cbEl('cardback-preview', suffix);
            var img      = cbEl('cardback-img', suffix);
            var dimsEl   = cbEl('cardback-dims', suffix);
            var removeBtn = cbEl('cardback-remove', suffix);
            var field    = cbEl('cardback-field', suffix);
            var verifyEl = cbEl('cardback-verify', suffix);

            function showMsg(text, isError) {
              if (!msgEl) return;
              msgEl.hidden = false; msgEl.textContent = text;
              msgEl.classList.toggle('is-error', !!isError);
            }
            function clearMsg() {
              if (!msgEl) return;
              msgEl.hidden = true; msgEl.textContent = ''; msgEl.classList.remove('is-error');
            }
            // Revert the preview to the standard card back (shown when no custom image is staged)
            function restoreDefaultPreview() {
              if (img) {
                if ((img.getAttribute('src') || '').indexOf('blob:') === 0) URL.revokeObjectURL(img.src);
                img.onload = null;
                img.classList.remove('is-custom-preview');
                img.src = img.getAttribute('data-cardback-default') || '';
              }
              if (dimsEl) dimsEl.textContent = 'Our standard back, no upload needed';
            }

            // Reset state for this tab before re-evaluating
            cardback[suffix] = null;
            if (field) { field.value = ''; field.disabled = true; }

            if (!file) {
              if (nameEl) nameEl.textContent = 'No file chosen';
              if (removeBtn) removeBtn.hidden = true;
              if (verifyEl) verifyEl.hidden = true;
              restoreDefaultPreview(); clearMsg();
              if (suffix === currentMode()) teardownCardbackTurnstile();
              if (suffix === 'images' && customDeckEditor && !restoringEditorCardback) {
                customDeckEditor.setDefaultBackFile(null);
              }
              validate();
              return;
            }

            if (nameEl) nameEl.textContent = file.name;
            if (removeBtn) removeBtn.hidden = false;

            if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
              if (verifyEl) verifyEl.hidden = true;
              restoreDefaultPreview(); showMsg('Unsupported file type. Please choose a PNG or JPG.', true);
              if (suffix === currentMode()) teardownCardbackTurnstile();
              validate();
              return;
            }
            if (file.size > CB_MAX_BYTES) {
              if (verifyEl) verifyEl.hidden = true;
              restoreDefaultPreview(); showMsg('That image is larger than 25MB. Please choose a smaller file.', true);
              if (suffix === currentMode()) teardownCardbackTurnstile();
              validate();
              return;
            }

            // Valid — stage it, swap in a preview thumbnail, then check dimensions on load
            cardback[suffix] = { file: file, name: file.name };
            if (suffix === 'images' && customDeckEditor && !restoringEditorCardback) {
              customDeckEditor.setDefaultBackFile(file);
            }
            clearMsg();
            if (img) {
              if ((img.getAttribute('src') || '').indexOf('blob:') === 0) URL.revokeObjectURL(img.src);
              img.classList.add('is-custom-preview');
              img.onload = function () {
                var w = img.naturalWidth, h = img.naturalHeight;
                if (dimsEl) dimsEl.textContent = w + ' × ' + h + ' px';
                var warn = ratioWarning(w, h);
                if (warn) showMsg(warn, false); else clearMsg();
              };
              img.src = URL.createObjectURL(file);
            }

            // Image-deck jobs bind their optional card back to the signed upload
            // session, so they do not need a second security challenge.
            if (suffix === currentMode() && suffix !== 'images') ensureCardbackTurnstile(suffix);
            validate();
          }

          function uploadCardback(file, token, deckToken) {
            if (!token) return Promise.reject(new Error('Please complete the verification check.'));
            if (!deckToken) return Promise.reject(new Error('Validate the active deck before uploading its custom card back.'));
            return timedFetch(WORKER_URL + '?type=cardback', {
              method: 'POST',
              headers: {
                'Content-Type': file.type,
                'CF-Turnstile-Response': token,
                'X-TRC-Deck-Validation': deckToken
              },
              body: file,
            }, file.size, function (res) {
              if (!res.ok) {
                return res.json().catch(function () { return { error: 'Upload failed' }; })
                  .then(function (d) { throw securityRejection(d, res.status) || new Error(d.error || 'Upload failed'); });
              }
              return res.json();
            });
          }

          // --- Multi-image order upload ---------------------------------
          // Files are naturally sorted once and that exact order is persisted
          // in the R2 manifest, so 2.png correctly comes before 10.png.
          var customImageFiles = [];
          var customImageLibraryCount = 0;
          var customImageHasDraft = false;
          var customImagesError = '';
          var customImagesUploadError = '';
          var customImagesUploading = false;
          var CUSTOM_IMAGE_MAX_BYTES = 50 * 1024 * 1024;
          var CUSTOM_IMAGE_TOTAL_MAX_BYTES = 8 * 1024 * 1024 * 1024;

          function naturalFilenameCompare(a, b) {
            return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
          }

          function customImageContentType(file) {
            if (file.type === 'image/png' || file.type === 'image/jpeg') return file.type;
            if (/\.png$/i.test(file.name)) return 'image/png';
            if (/\.jpe?g$/i.test(file.name)) return 'image/jpeg';
            return '';
          }

          function formatBytes(value) {
            var bytes = Number(value || 0);
            if (bytes < 1024) return bytes + ' B';
            var units = ['KB', 'MB', 'GB'];
            var index = -1;
            do { bytes /= 1024; index++; } while (bytes >= 1024 && index < units.length - 1);
            return bytes.toFixed(bytes >= 100 ? 0 : bytes >= 10 ? 1 : 2) + ' ' + units[index];
          }

          function customImageRangeLabel() {
            return exactQuantity ? String(exactQuantity.imageCount()) : 'up to ' + TARGET;
          }

          var emptySlotsDialogOpen = false;
          function emptyImageHelp() {
            return customImageLibraryCount > 0
              ? 'Place your uploaded images into card slots in the deck editor.'
              : 'Upload images in the deck editor.';
          }
          function canClearEmptySlots() {
            return !!exactQuantity && !!customDeckEditor && customDeckValidation.incomplete === true &&
              customImageFrontCount > 0 && customImageFrontCount < exactQuantity.imageCount();
          }
          function customImageCountValid() {
            return !customImagesError && customDeckValidation.valid &&
              customImageFrontCount >= 1 && customImageFrontCount <= TARGET;
          }

          function renderCustomImages() {
            if (!customImagesStatus || !customImagesSummary) return;
            var imageTarget = exactQuantity ? exactQuantity.imageCount() : TARGET;
            // Native required-field validation runs before the submit listener.
            // A confirmable draft must reach that listener; upload still waits for compaction.
            var canSubmitImages = customImageCountValid() || canClearEmptySlots();
            if (canSubmitImages && !customImagesManifest.value) customImagesManifest.value = 'ready';
            if (!canSubmitImages && customImagesManifest.value === 'ready') customImagesManifest.value = '';
            var totalBytes = customImageFiles.reduce(function (sum, file) { return sum + file.size; }, 0);
            customImagesSummary.classList.toggle('is-error', (!canClearEmptySlots() && (!!customImagesError || (customImageFrontCount > 0 && !customImageCountValid()))) || !!customImagesUploadError);
            customImagesSummary.classList.toggle('is-valid', customImageCountValid() && !customDeckValidation.warning && !customImagesUploading);
            if (customImagesError) {
              customImagesStatus.textContent = customImagesError;
            } else if (customImagesUploadError) {
              customImagesStatus.textContent = customImagesUploadError;
            } else if (customDeckValidation.warning && customDeckValidation.message) {
              customImagesStatus.textContent = customDeckValidation.message;
            } else if (!customImageFrontCount) {
              customImagesStatus.textContent = emptyImageHelp();
            } else if (!customImageCountValid()) {
              customImagesStatus.textContent = customDeckValidation.message || (customImageFrontCount + ' fronts assigned');
            } else if (/\|https?:\/\//.test(customImagesManifest.value)) {
              customImagesStatus.textContent = customImageFrontCount + ' / ' + imageTarget + ' cards ready';
            } else {
              customImagesStatus.textContent = customImageFrontCount + ' / ' + imageTarget + ' cards';
            }
            if (customImagesSize) customImagesSize.textContent = customImageFiles.length ? formatBytes(totalBytes) : '';
            if (customImagesClear) customImagesClear.hidden = !customImageHasDraft;
            if (customImagesList) {
              customImagesList.hidden = true;
            }
          }

          function stageCustomImages(fileList) {
            customImagesError = '';
            customImagesUploadError = '';
            customImagesManifest.value = '';
            var files = Array.from(fileList || []).sort(naturalFilenameCompare);
            var names = new Set();
            var totalBytes = 0;
            for (var i = 0; i < files.length; i++) {
              var file = files[i];
              var normalized = file.name.normalize('NFKC').toLowerCase();
              if (names.has(normalized)) {
                customImagesError = 'Duplicate filename: ' + file.name;
                break;
              }
              names.add(normalized);
              if (!customImageContentType(file)) {
                customImagesError = file.name + ' is not a PNG or JPG';
                break;
              }
              if (!file.size || file.size > CUSTOM_IMAGE_MAX_BYTES) {
                customImagesError = file.name + ' is larger than 50 MB';
                break;
              }
              totalBytes += file.size;
              if (totalBytes > CUSTOM_IMAGE_TOTAL_MAX_BYTES) {
                customImagesError = 'This upload is larger than 8 GB';
                break;
              }
            }
            customImageFiles = customImagesError ? [] : files;
            renderCustomImages();
            validate();
          }

          function customImagesRequest(action, options) {
            options = options || {};
            var query = '?type=custom-images&action=' + encodeURIComponent(action);
            if (options.session) query += '&session=' + encodeURIComponent(options.session);
            if (options.index != null) query += '&index=' + encodeURIComponent(options.index);
            var body = options.body;
            var bodyBytes = body == null ? 0 : (typeof body === 'string' ? body.length : Number(body.size || 0));
            return timedFetch(WORKER_URL + query, {
              method: 'POST',
              headers: options.headers || {},
              body: body,
            }, bodyBytes, function (res) {
              return res.json().catch(function () { return { error: 'Upload failed' }; }).then(function (data) {
                if (!res.ok) {
                  var requestError = securityRejection(data, res.status) || new Error(data.error || 'Upload failed');
                  requestError.status = res.status;
                  requestError.retryable = res.status === 408 || res.status === 429 || res.status >= 500;
                  throw requestError;
                }
                return data;
              });
            });
          }

          function shouldRetryUpload(error) {
            return !error || error.status == null || error.retryable === true;
          }

          function customImagesRequestWithRetry(action, options, attempt) {
            return customImagesRequest(action, options).catch(function (error) {
              if ((attempt || 0) >= 2 || !shouldRetryUpload(error)) throw error;
              return new Promise(function (resolve) { setTimeout(resolve, 500 * Math.pow(2, attempt || 0)); })
                .then(function () { return customImagesRequestWithRetry(action, options, (attempt || 0) + 1); });
            });
          }

          function uploadCustomImageWithRetry(file, index, session, token, attempt) {
            return customImagesRequest('upload', {
              session: session,
              index: index,
              headers: { 'Content-Type': customImageContentType(file), 'X-TRC-Upload-Token': token },
              body: file,
            }).catch(function (error) {
              if ((attempt || 0) >= 2 || !shouldRetryUpload(error)) throw error;
              return new Promise(function (resolve) { setTimeout(resolve, 500 * Math.pow(2, attempt || 0)); })
                .then(function () { return uploadCustomImageWithRetry(file, index, session, token, (attempt || 0) + 1); });
            });
          }

          function createCustomImagePreview(file) {
            return new Promise(function (resolve, reject) {
              var objectUrl = URL.createObjectURL(file);
              var image = new Image();
              function cleanup() { URL.revokeObjectURL(objectUrl); }
              image.onload = function () {
                try {
                  var scale = Math.min(1, 480 / image.naturalWidth, 672 / image.naturalHeight);
                  var width = Math.max(1, Math.round(image.naturalWidth * scale));
                  var height = Math.max(1, Math.round(image.naturalHeight * scale));
                  var canvas = document.createElement('canvas');
                  canvas.width = width;
                  canvas.height = height;
                  var context = canvas.getContext('2d', { alpha: false });
                  if (!context) throw new Error('Your browser could not prepare the cart preview.');
                  context.fillStyle = '#fff';
                  context.fillRect(0, 0, width, height);
                  context.drawImage(image, 0, 0, width, height);
                  canvas.toBlob(function (blob) {
                    cleanup();
                    if (!blob) return reject(new Error('Your browser could not prepare the cart preview.'));
                    if (blob.size > 512 * 1024) return reject(new Error('A cart preview was unexpectedly large.'));
                    resolve(blob);
                  }, 'image/jpeg', 0.72);
                } catch (error) {
                  cleanup();
                  reject(error);
                }
              };
              image.onerror = function () {
                cleanup();
                reject(new Error(file.name + ' could not be decoded for its cart preview.'));
              };
              image.src = objectUrl;
            });
          }

          function uploadCustomImagePreviewWithRetry(file, index, session, token) {
            return createCustomImagePreview(file).then(function (preview) {
              return customImagesRequestWithRetry('preview', {
                session: session,
                index: index,
                headers: { 'Content-Type': 'image/jpeg', 'X-TRC-Upload-Token': token },
                body: preview,
              }, 0);
            });
          }

          // The in-page uploader: used when this browser cannot store the images
          // for the background upload manager. The page must stay open.
          // The deck an in-page upload sends, fixed when it starts: edits or a tab
          // switch while it runs never mix into it or add a different deck.
          function imageDeckSnapshot() {
            return {files: customImageFiles.slice(), slots: JSON.stringify(customImageSlots), slotList: customImageSlots.slice(),
              variant: selectedVariantId(), back: cardback.images || null};
          }
          function imageDeckUnchanged(snapshot) {
            return !lifecycle.signal.aborted && currentMode() === 'images' && selectedVariantId() === snapshot.variant &&
              (cardback.images || null) === snapshot.back && JSON.stringify(customImageSlots) === snapshot.slots &&
              customImageFiles.length === snapshot.files.length &&
              customImageFiles.every(function (file, index) { return file === snapshot.files[index]; });
          }
          var DECK_CHANGED_COPY = 'Your deck changed while it was uploading. Press Add to cart again.';
          function uploadCustomImages(keepOpen) {
            if (lifecycle.signal.aborted) return Promise.reject(new Error('Product closed.'));
            if (!customImagesToken) return Promise.reject(new Error('Please complete the verification check.'));
            customImagesUploadError = '';
            customImagesUploading = true;
            var snapshot = imageDeckSnapshot();
            var deckFiles = snapshot.files;
            function showSubmitProgress(message, percent) {
              showSubmitProgressBox(keepOpen ? message + (/[.…!?]$/.test(message) ? '' : '.') + ' Keep this page open.' : message, percent);
            }
            // Leaving the page would stop this upload: ask first where the browser allows it.
            function warnBeforeLeaving(event) { event.preventDefault(); event.returnValue = ''; return ''; }
            window.addEventListener('beforeunload', warnBeforeLeaving);
            function stopWarning() { window.removeEventListener('beforeunload', warnBeforeLeaving); }
            showSubmitProgress('Preparing secure upload…');
            var tokenForSession = customImagesToken;
            var activeSession = null;
            var metadata = deckFiles.map(function (file) {
              return { name: file.name, type: customImageContentType(file), size: file.size };
            });
            // Spent once the Worker sees it: a retry waits for a fresh token.
            consumeCustomImagesToken(tokenForSession);
            return customImagesRequest('start', {
              headers: {
                'Content-Type': 'application/json',
                'CF-Turnstile-Response': tokenForSession,
              },
              body: JSON.stringify({
                variantId: snapshot.variant,
                files: metadata,
                slots: snapshot.slotList,
              }),
            }).then(function (session) {
              activeSession = session;
              // The Worker may extend the session with a fresh token on any reply.
              function adoptToken(reply) { if (reply && typeof reply.token === 'string' && reply.token) session.token = reply.token; return reply; }
              var next = 0;
              var completed = 0;
              var largestImage = deckFiles.reduce(function (largest, file) {
                return Math.max(largest, Number(file.size || 0));
              }, 0);
              // Large uploads are intentionally serialized to stay inside a
              // Cloudflare Worker isolate's memory ceiling while it verifies
              // the full PNG/JPG before committing it to R2.
              var uploadConcurrency = largestImage > 25 * 1024 * 1024 ? 1 : (largestImage > 10 * 1024 * 1024 ? 2 : 4);
              var workerCount = Math.min(uploadConcurrency, deckFiles.length);
              showSubmitProgress('Uploading cards: 0 of ' + deckFiles.length, 0);
              function runWorker() {
                var index = next++;
                if (index >= deckFiles.length) return Promise.resolve();
                return uploadCustomImageWithRetry(deckFiles[index], index, session.session, session.token, 0)
                  .then(adoptToken).then(function () {
                    completed++;
                    var percent = Math.round((completed / deckFiles.length) * 85);
                    showSubmitProgress('Uploading cards: ' + completed + ' of ' + deckFiles.length, percent);
                    return runWorker();
                  });
              }
              var workers = [];
              for (var i = 0; i < workerCount; i++) workers.push(runWorker());
              return Promise.all(workers).then(function () {
                var previewNext = 0;
                var previewCompleted = 0;
                function runPreviewWorker() {
                  var index = previewNext++;
                  if (index >= deckFiles.length) return Promise.resolve();
                  return uploadCustomImagePreviewWithRetry(deckFiles[index], index, session.session, session.token)
                    .then(adoptToken).then(function () {
                      previewCompleted++;
                      var completedPercent = 85 + Math.round((previewCompleted / deckFiles.length) * 14);
                      showSubmitProgress('Preparing cart previews: ' + previewCompleted + ' of ' + deckFiles.length, completedPercent);
                      return runPreviewWorker();
                    });
                }
                showSubmitProgress('Preparing cart previews: 0 of ' + deckFiles.length, 85);
                var previewWorkers = [];
                var previewWorkerCount = Math.min(4, deckFiles.length);
                for (var previewWorker = 0; previewWorker < previewWorkerCount; previewWorker++) previewWorkers.push(runPreviewWorker());
                return Promise.all(previewWorkers);
              }).then(function () {
                showSubmitProgress('Finalizing upload…', 100);
                return customImagesRequestWithRetry('complete', {
                  session: session.session,
                  headers: { 'X-TRC-Upload-Token': session.token },
                }, 0);
              }).then(function (result) {
                // A staged card back is bound to the finished session (no second
                // security check); its reply replaces the deck proof.
                var staged = snapshot.back;
                if (!staged || !staged.file || !imageDeckUnchanged(snapshot)) return result;
                activeSession = null;
                showSubmitProgress('Uploading card back…', 100);
                return customImagesRequestWithRetry('cardback', {
                  session: session.session,
                  headers: { 'Content-Type': customImageContentType(staged.file) || staged.file.type || 'image/png', 'X-TRC-Upload-Token': session.token },
                  body: staged.file,
                }, 0).then(function (back) {
                  if (!back || !back.url || !cbEl('cardback-field', 'images')) throw new Error('The card back could not be uploaded.');
                  return Object.assign({}, result, {validationToken: back.validationToken || result.validationToken,
                    cardbackValue: (staged.name || 'card-back.png').replace(/\|/g, '-') + '|' + back.url});
                });
              });
            }).then(function (result) {
              activeSession = null;
              if (!imageDeckUnchanged(snapshot)) throw Object.assign(new Error(DECK_CHANGED_COPY), {deckChanged: true});
              if (result.cardbackValue) {
                var field = cbEl('cardback-field', 'images');
                field.disabled = false;
                field.value = result.cardbackValue;
              }
              customImagesManifest.value = result.count + ' custom cards|' + result.manifestUrl;
              setDeckValidation('images', result.validationToken || '');
              customImagesUploading = false;
              stopWarning();
              renderCustomImages();
              return result;
            }).catch(function (error) {
              stopWarning();
              if (activeSession) {
                customImagesRequest('cancel', {
                  session: activeSession.session,
                  headers: { 'X-TRC-Upload-Token': activeSession.token },
                }).catch(function () {});
              }
              customImagesUploading = false;
              customImagesUploadError = withRetryHint(error.message);
              hideSubmitProgress();
              if (error && error.deckChanged) {
                // Nothing of the old upload stays on the form.
                customImagesManifest.value = '';
                setDeckValidation('images', '');
                if (currentMode() !== 'images') showSubmitNotice(DECK_CHANGED_COPY);
              }
              renderCustomImages();
              refreshCustomImagesChallenge();
              throw error;
            });
          }

          function mountCustomDeckEditor() {
            if (customDeckEditor || !window.TRCImageDeckEditor) return;
            customDeckEditor = window.TRCImageDeckEditor.mount({
              root: byId('trcDeckEditorRoot'),
              minimum: 1,
              maximum: exactQuantity ? exactQuantity.imageCount() : (exactConfig ? 100 : TARGET),
              exactQuantity: !!exactConfig,
              persistenceKey: deckInputConfig.CUSTOM_DECK_PERSISTENCE_PREFIX + (window.TRCAdminDecks && window.TRCAdminDecks.connection ? ':admin:' + window.TRCAdminDecks.connection.id : ''),
              onRestoreDefaultBack: function (file) {
                restoringEditorCardback = true;
                stageCardback('images', file || null);
                restoringEditorCardback = false;
              },
              onChange: function (plan, result) {
                if (exactQuantity && plan.selectedCount) exactQuantity.restoreCount(plan.selectedCount);
                incompleteDeckConfirmed = false;
                customImageFiles = plan.files || [];
                customImageLibraryCount = Number(plan.totalLibraryFiles || 0);
                customImageHasDraft = !!plan.hasDraft;
                customImageSlots = plan.slots || [];
                customImageFrontCount = Number(plan.count || 0);
                if (exactQuantity) exactQuantity.showFilled(customImageFrontCount);
                customDeckValidation = result || { valid: false, message: '' };
                customImagesError = customDeckValidation.valid ? '' : (customDeckValidation.message || '');
                if (/\|https?:\/\//.test(customImagesManifest.value)) {
                  customImagesManifest.value = '';
                  clearDeckValidation();
                }
                uploadedArtPreviews.images = plan.previewCards && plan.previewCards.length ? {profileName: 'Custom images', cards: plan.previewCards} : null;
                renderCustomImages();
                validate();
                scheduleProfilePreview('images');
              },
            });
          }

          if (window.TRCImageDeckEditor) {
            mountCustomDeckEditor();
          } else {
            listen(document, 'trc-image-deck-editor-ready', mountCustomDeckEditor, { once: true });
          }

          // Holds validated XML text until submit-time upload
          var xmlText = null;
          var xmlTwoSided = 0;
          var cardCount = 0;
          var xmlCardCount = 0;
          var xmlFileNameValue = null;

          function currentMode() {
            if (IS_CREATOR_DECK) return 'link';
            var r = root.querySelector('.deck-input__radio:checked');
            if (r) return r.getAttribute('data-mode');
            return root.getAttribute('data-active-mode') || 'link';
          }

          function syncModeSelection(mode) {
            if (IS_CREATOR_DECK) mode = 'link';
            if (['text', 'link', 'xml', 'images'].indexOf(mode) === -1) mode = 'link';
            root.setAttribute('data-active-mode', mode);
            radios.forEach(function (radio) {
              var active = radio.getAttribute('data-mode') === mode;
              radio.checked = active;
              var tab = radio.nextElementSibling;
              if (tab && tab.classList.contains('deck-input__tab')) {
                tab.classList.toggle('is-active', active);
              }
            });
            return mode;
          }

          function restoreStoredMode() {
            if (IS_CREATOR_DECK) return;
            var saved = '';
            try { saved = window.localStorage.getItem(MODE_STORAGE_KEY) || ''; } catch (ignore) {}
            if (['text', 'link', 'xml', 'images'].indexOf(saved) === -1) return;
            var radio = root.querySelector('.deck-input__radio[data-mode="' + saved + '"]');
            if (radio) radio.checked = true;
          }

          function rememberMode(mode) {
            if (IS_CREATOR_DECK) return;
            try { window.localStorage.setItem(MODE_STORAGE_KEY, mode); } catch (ignore) {}
          }

          function placeDeckVariantPicker(mode) {
            var activePicker = exactRoot || deckVariantPicker;
            if (!activePicker) return;
            var target = null;
            if (mode === 'text' || mode === 'link') {
              target = root.querySelector('.deck-input__panel[data-panel="' + mode + '"] .deck-input__art-sticky');
            }
            if (!target && IS_CUSTOM_DECK) {
              target = root.querySelector('[data-trc-custom-variant-slot="' + mode + '"]');
              if (!target) target = root.querySelector('[data-trc-custom-variant-slot="link"]');
            }
            if (!target) return;
            activePicker.classList.toggle('deck-input__sticky-variants', target.classList.contains('deck-input__art-sticky'));
            if (activePicker.parentNode !== target) target.insertBefore(activePicker, target.firstChild);
            activePicker.querySelectorAll('input[name], select[name]').forEach(function (control) {
              if (!control.hasAttribute('data-exact-property')) control.disabled = false;
            });
            queueStickyArtShadowUpdate();
          }

          function artChosen(mode) {
            return !!root.querySelector('input[name="properties[Art style]"][data-art="' + mode + '"]:checked');
          }

          // True only if EVERY card line has set code + collector number (qty name (SET) num [*F*])
          function deckHasFullSetSyntax() {
            // Read as the Worker signs it (cleanDecklistText), so an Archidekt
            // "[Category]" block does not hide a line's printing.
            var lines = cleanDecklistText(textarea.value).split('\n');
            var cardLines = 0;
            for (var i = 0; i < lines.length; i++) {
              var line = lines[i].trim();
              if (!line || /^\/\//.test(line)) continue;
              if (isSectionHeader(line)) continue;
              cardLines++;
              if (!/^\d+\s*x?\s+.+\s+\([A-Za-z0-9]{2,6}\)\s+[0-9A-Za-z★-]+\s*(\*[A-Za-z]\*)?\s*$/i.test(line)) {
                return false;  // one non-matching line disqualifies the whole deck
              }
            }
            return cardLines > 0;  // at least one card, and all matched
          }
          
          function setMode(mode) {
            // Another tab's art is not preloaded behind this one.
            cancelProfileImagePreloads();
            if (exactQuantity) exactQuantity.setMode(mode);
            mode = syncModeSelection(mode);
            rememberMode(mode);
            requirementsRevealed = false;
            hideSubmitProgress();
            // Values stay in the DOM so users can return to unfinished work on
            // another tab; disabled controls are omitted from FormData.
            panels.forEach(function (p) {
              var active = p.getAttribute('data-panel') === mode;
              p.hidden = !active;
              // Start from a deny-by-default state so inactive tabs can neither
              // block native validation nor leak stale line-item properties.
              p.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (control) {
                control.disabled = true;
              });
            });
            placeDeckVariantPicker(mode);
            textarea.disabled = mode !== 'text';
            urlInput.disabled = mode !== 'link';
            if (IS_CREATOR_DECK) {
              urlInput.value = (deckValidationResult.link && deckValidationResult.link.url) || FIXED_DECK_URL;
              urlInput.readOnly = true;
            }
            if (sideboardCheck) sideboardCheck.disabled = mode !== 'link';
            if (companionPanel) showCompanion(companionOptions);
            xmlInput.disabled = mode !== 'xml';
            customImagesInput.disabled = mode !== 'images';
            customImagesManifest.disabled = mode !== 'images';
            if (deckValidationVerify) deckValidationVerify.hidden = mode === 'images';
            if (deckSecurityStatus) deckSecurityStatus.hidden = mode === 'images' || !deckSecurityStatus.textContent;
            // Only the active tab's art radios submit + count toward validation
            artRadios.forEach(function (r) { r.disabled = r.getAttribute('data-art') !== mode; });
            // Card back: only the active tab's file input is usable; its hidden field is
            // enabled only once an image has actually been uploaded (so we never send an empty prop).
            cardbackFileInputs.forEach(function (i) { i.disabled = i.getAttribute('data-cardback-file') !== mode; });
            cardbackFields.forEach(function (f) {
              var owner = f.getAttribute('data-cardback-field');
              var hasUrl = /\|https?:\/\//.test(f.value);
              f.disabled = !(owner === mode && hasUrl);
            });
            // Turnstile follows the active tab, and only when that tab has a not-yet-uploaded image.
            teardownCardbackTurnstile();
            root.querySelectorAll('[data-cardback-verify]').forEach(function (v) { v.hidden = true; });
            if (cardbackState(mode) === 'staged' && mode !== 'images') ensureCardbackTurnstile(mode);
            // Exact-quantity pricing resets its card count on every tab switch,
            // which moves the form to another variant. Settle this tab's variant
            // before comparing validation keys, or a verified deck looks stale.
            if (exactQuantity && mode === 'text') tally();
            if (exactQuantity && mode === 'link' && deckValidationResult.link && deckValidationResult.link.quote) {
              try { exactQuantity.adopt(deckValidationResult.link.quote); } catch (ignore) {}
            }
            applyDeckValidation(mode);
            if (mode === 'images') scheduleProfilePreview(mode);
            if (mode === 'text' || mode === 'link') {
              var cacheKey = profilePreviewCacheKey(mode);
              if (deckValidationResult[mode] && deckValidationResultKey[mode] === cacheKey) {
                applyDeckValidationResult(mode, deckValidationResult[mode], cacheKey);
              } else {
                scheduleProfilePreview(mode);
              }
            }
            validate();
            // Solved while the shopper picks images, so Add to cart need not
            // wait. Last, so the tab switch above is always fully applied.
            if (mode === 'images') wantCustomImagesWidget();
          }

          // The list's own problem (no server check needed), or ''. Counts the
          // list as the Worker signs it (cleanDecklistText): section headers
          // (Commander, Companion, Sideboard (15), ...) and Arena's About and Name
          // lines are not cards; Archidekt [Category] and ^Label^ blocks are ignored.
          var textListIssue = '';
          function tally() {
            var counted = F.tallyDecklist(textarea.value);
            var total = counted.total;
            cardCount = total;
            var pricedCount = counted.invalidLines ? 0 : total;
            if (exactQuantity && currentMode() === "text" && exactQuantity.count() !== pricedCount) exactQuantity.setCount(pricedCount,"text");
            textListIssue = F.textListIssue(counted, {minimum: MINIMUM, maximum: TARGET, commanderCompanion: root.hasAttribute('data-commander-companion'),
              boardByVariant: boardByVariant, board: sideboardCheck && sideboardCheck.value});
            if (textListIssue) {
              textarea.setCustomValidity(textListIssue);
            } else if (deckValidationErrorKey.text === profilePreviewCacheKey('text') && deckValidationError.text) {
              textarea.setCustomValidity(deckValidationError.text.message || 'Card names could not be checked. Please retry.');
            } else {
              textarea.setCustomValidity('');  // clears the error
            }
            count.textContent = F.countLabel(total, TARGET, exactConfig);
            count.classList.toggle('is-full', total === TARGET);
            count.classList.toggle('is-over', total > TARGET);
          }

          function clearRequirementHighlights() {
            highlightedRequirements.forEach(function (element) {
              element.classList.remove('deck-input__requirement-missing');
              if (element.matches && element.matches('input, textarea, select')) {
                element.removeAttribute('aria-invalid');
              }
            });
            highlightedRequirements = [];
          }

          function renderSubmitRequirements(ok, issues, targets) {
            clearRequirementHighlights();
            // An init that threw part way (see deckInputInitFailed) keeps its refresh message.
            if (!submitRequirements || submitRequirements.hasAttribute('data-trc-init-failed')) return;
            var show = requirementsRevealed && !ok;
            submitRequirements.hidden = !show;
            submitRequirements.textContent = '';
            if (!show) return;

            var heading = document.createElement('strong');
            heading.textContent = 'Please fix the following:';
            var list = document.createElement('ul');
            issues.forEach(function (message) {
              var item = document.createElement('li');
              item.textContent = message;
              list.appendChild(item);
            });
            submitRequirements.appendChild(heading);
            submitRequirements.appendChild(list);

            targets.forEach(function (element) {
              if (!element || highlightedRequirements.indexOf(element) !== -1) return;
              element.classList.add('deck-input__requirement-missing');
              if (element.matches && element.matches('input, textarea, select')) {
                element.setAttribute('aria-invalid', 'true');
              }
              highlightedRequirements.push(element);
            });
          }

          // A one-off message beside the button; the next validation pass
          // replaces it with the current requirements.
          function showSubmitNotice(message) {
            if (submitRequirements && submitRequirements.hasAttribute('data-trc-init-failed')) return;
            if (submitRequirements) {
              clearRequirementHighlights();
              submitRequirements.textContent = message;
              submitRequirements.hidden = false;
            } else if (textValidationStatus && currentMode() === 'text') {
              updateTextValidationStatus('error', message);
            }
          }

          function showSubmitProgressBox(message, percent) { showSubmitProgress(message, percent); }
          function showSubmitProgress(message, percent) {
            if (!submitProgress || !submitProgressBar) return;
            var determinate = Number.isFinite(percent);
            var boundedPercent = determinate ? Math.max(0, Math.min(100, Math.round(percent))) : 0;
            submitProgress.hidden = false;
            submitProgress.classList.toggle('is-indeterminate', !determinate);
            if (submitProgressStatus) submitProgressStatus.textContent = message || 'Working…';
            if (submitProgressPercent) submitProgressPercent.textContent = determinate ? boundedPercent + '%' : '';
            submitProgressBar.style.width = determinate ? boundedPercent + '%' : '';
            if (submitProgressTrack) {
              if (determinate) submitProgressTrack.setAttribute('aria-valuenow', String(boundedPercent));
              else submitProgressTrack.removeAttribute('aria-valuenow');
            }
          }

          function hideSubmitProgress() {
            if (!submitProgress) return;
            submitProgress.hidden = true;
            submitProgress.classList.remove('is-indeterminate');
            if (submitProgressPercent) submitProgressPercent.textContent = '';
            if (submitProgressBar) submitProgressBar.style.width = '0%';
            if (submitProgressTrack) submitProgressTrack.removeAttribute('aria-valuenow');
          }

          function finishSubmitProgress() {
            showSubmitProgress('Adding to cart…', 100);
          }

          function cartAddInFlight() {
            return !!(submitBtn && submitBtn.classList.contains('btn--loading'));
          }

          // Returns true if the active tab is valid
          function validate() {
            var mode = currentMode(), ok = false, issues = [], issueTargets = [];
            if (submitConfirm && submitConfirm.controller && !submitConfirm.stillCurrent()) submitConfirm.controller.abort();
            applyDeckValidation(mode);
            syncTwoSidedNotice();
            updateDeckRefreshButton();
            function issue(message, target) {
              if (message && issues.indexOf(message) === -1) issues.push(message);
              if (target && issueTargets.indexOf(target) === -1) issueTargets.push(target);
            }
            if (mode === 'text') {
              tally();
              updateTextValidationRetry();
              // Reveal "Your Exact Printings" only when every card line carries set + collector number
              var exactOpt = root.querySelector('[data-exact-opt="text"]');
              var exactRadio = exactOpt ? exactOpt.querySelector('input') : null;
              var showExact = deckHasFullSetSyntax();
              if (exactOpt) exactOpt.hidden = !showExact;
              if (!showExact && exactRadio && exactRadio.checked) { exactRadio.checked = false; }
              ok = !textarea.validationMessage && cardCount >= MINIMUM && cardCount <= TARGET && artChosen('text') &&
                (!!deckValidationField.value || turnstileToken !== null);
              if (textarea.validationMessage) issue(textarea.validationMessage, textarea);
              if (!artChosen('text')) issue('Choose an art style.', root.querySelector('.deck-input__panel[data-panel="text"] .deck-input__art'));
              if (!deckValidationField.value && turnstileToken === null) issue(securityError || 'Wait for the security check to finish.', deckValidationVerify);
            } else if (mode === 'link') {
              var u = urlInput.value.trim();
              var urlOk = validDeckUrl(u);
              var art = artChosen('link');
              ok = urlOk && art && (!!deckValidationField.value || turnstileToken !== null);
              if (companionPanel && !companionPanel.hidden && (companionChoice() && !companionOptions.available)) { ok = false; issue('Remove the companion or choose an available print option.', companionPanel); }
              if (!urlOk) issue(F.deckLinkIssue(urlInput.value), urlInput);
              if (!art) issue('Choose an art style.', root.querySelector('.deck-input__panel[data-panel="link"] .deck-input__art'));
              if (!deckValidationField.value && turnstileToken === null) issue(securityError || 'Wait for the deck check to finish.', deckValidationVerify);
            } else if (mode === 'xml') {
              // Over-limit: file was rejected (xmlText null) but we have a count to report.
              var overLimit = xmlCardCount > TARGET;
              ok = (xmlText !== null || /\|https?:\/\//.test(xmlInput.value)) &&
                xmlCardCount >= MINIMUM && xmlCardCount <= TARGET &&
                (!!deckValidationField.value || turnstileToken !== null);
              var xmlPicker = root.querySelector('.deck-input__panel[data-panel="xml"] .deck-input__file');
              if (xmlText === null && !/\|https?:\/\//.test(xmlInput.value)) issue('Upload an MPC Fill XML file.', xmlPicker);
              if (xmlCardCount > 0 && xmlCardCount < MINIMUM) issue(F.minimumMessage(MINIMUM), xmlPicker);
              if (overLimit) issue(F.overLimitMessage(xmlCardCount, TARGET), xmlPicker);
              if (!deckValidationField.value && turnstileToken === null) issue(securityError || 'Wait for the security check to finish.', deckValidationVerify);

              // Custom validity on the hidden field → same native bubble as the text tab,
              // instead of the generic "Please fill out this field".
              if (overLimit) {
                xmlInput.setCustomValidity(F.overLimitMessage(xmlCardCount, TARGET));
              } else {
                xmlInput.setCustomValidity('');
              }

              if (xmlStatus) {
                xmlStatus.parentElement.hidden = xmlCardCount <= 0;
                xmlStatus.classList.remove('is-over', 'is-full');
                if (overLimit) {
                  xmlStatus.textContent = F.countLabel(xmlCardCount, TARGET, exactConfig);
                  xmlStatus.classList.add('is-over');
                } else if (xmlCardCount > 0) {
                  var xmlShortBy = underCountMessage(xmlCardCount);
                  xmlStatus.textContent = F.countLabel(xmlCardCount, TARGET, exactConfig) + (xmlShortBy ? '. ' + xmlShortBy : '');
                  if (xmlCardCount === TARGET) xmlStatus.classList.add('is-full');
                  // D-11: point at the check only while one is actually showing.
                  if (!turnstileToken && !deckValidationField.value && deckChallengeInteractive) {
                    xmlStatus.textContent += (xmlShortBy ? ' ' : '. ') + 'Complete the security check below.';
                  }
                } else {
                  xmlStatus.textContent = '';
                }
              }
            } else if (mode === 'images') {
              var imageCountOk = customImageCountValid() || canClearEmptySlots();
              var imageEditorTarget = byId('trcDeckEditorRoot') || customImagesSummary;
              ok = imageCountOk && !customImagesUploading;
              if (customImagesError && !canClearEmptySlots()) {
                customImagesManifest.setCustomValidity(customImagesError);
                issue(customImagesError, imageEditorTarget);
              } else if (!imageCountOk) {
                customImagesManifest.setCustomValidity(emptyImageHelp());
                issue(customDeckValidation.message || emptyImageHelp(), imageEditorTarget);
              } else {
                customImagesManifest.setCustomValidity('');
              }
              if (customImagesUploadError) issue(customImagesUploadError, imageEditorTarget);
              if (customImagesUploading) issue('Wait for your images to finish uploading.', customImagesSummary);
              renderCustomImages();
            }
            // Card back is optional: it never blocks add-to-cart when absent. But if a valid
            // image IS staged on the active tab, require its Turnstile token before submit.
            if (mode === 'text' || mode === 'link') {
              if (cardbackState(mode) === 'staged' && cardbackToken === null) {
                ok = false;
                issue('Wait for the custom card-back security check to finish.', cbEl('cardback-verify', mode));
              }
            }
            if (exactConfig && !exactQuantity) { ok = false; issue("Loading card pricing…", exactRoot); }
            if (exactQuantity && !exactQuantity.valid() && mode !== "link") { ok = false; issue("Add a valid card list or choose your image card quantity.",exactRoot); }
            var twoSidedAck = twoSidedAckMissing();
            if (twoSidedAck) { ok = false; issue('Confirm that foil prints on card fronts only.', twoSidedAck); }
            if (variantChangePending()) {
              ok = false;
              issue('Updating the selected option…', submitBtn);
            }
            var unavailable = submitBtn && submitBtn.getAttribute('data-trc-unavailable') === 'true';
            if (unavailable) {
              ok = false;
              issue('This product or selected option is currently unavailable.', submitBtn);
            }
            if (!ok && !issues.length) {
              issue(
                mode === 'images'
                  ? 'Open the Deck editor and wait for the card-image check to finish.'
                  : 'Review the required fields in this tab.',
                mode === 'images' ? (byId('trcDeckEditorRoot') || customImagesSummary) : root.querySelector('.deck-input__panel[data-panel="' + mode + '"]')
              );
            }
            if (submitBtn) {
              var busy = !!uploading || customImagesUploading || variantChangePending();
              submitBtn.disabled = !!unavailable || busy;
              submitBtn.classList.toggle('is-trc-validation-disabled', !ok && !unavailable && !busy);
              // While the theme's cart add is in flight (btn--loading), keep its
              // aria-disabled guard: re-validating must never re-arm a second add.
              if (ok && !busy && !cartAddInFlight()) {
                // The theme treats the *presence* of aria-disabled as disabled,
                // even when its value is "false".
                submitBtn.removeAttribute('aria-disabled');
              } else {
                submitBtn.setAttribute('aria-disabled', 'true');
              }
            }
            if (submitLabel) {
              submitLabel.textContent = submitLabel.getAttribute('data-add-label');
            }
            if (ok) requirementsRevealed = false;
            renderSubmitRequirements(ok, issues, issueTargets);
            if (mode === 'text' && textarea.validationMessage) textarea.setAttribute('aria-invalid', 'true');
            else textarea.removeAttribute('aria-invalid');
            return ok;
          }

          var XML_PLACES_ERROR = 'the cards in this file are not numbered correctly. Export the file again from mpcfill.com and upload the new file.';
          function parseUploadedXmlPreview(doc) {
            var positions = new Set();
            var cards = Array.from(doc.querySelectorAll('fronts > card')).map(function (card) {
              var id = (card.querySelector('id') || {}).textContent || '';
              id = id.trim();
              if (!/^[A-Za-z0-9_-]{10,200}$/.test(id)) throw new Error('a card uses an image from your computer, which we can\u2019t print. Choose an online image for it on mpcfill.com, then export the file again.');
              var raw = (card.querySelector('slots') || {}).textContent || '';
              var slots = raw.split(',');
              slots.forEach(function (slot) {
                if (!/^\d+$/.test(slot.trim())) throw new Error(XML_PLACES_ERROR);
                var position = Number(slot.trim());
                if (position >= 1000 || positions.has(position)) throw new Error(XML_PLACES_ERROR);
                positions.add(position);
              });
              return {name: ((card.querySelector('name') || {}).textContent || 'Uploaded card').trim(), quantity: slots.length};
            });
            var count = positions.size;
            if (!count || Array.from(positions).some(function (position) {return position >= count;})) throw new Error(XML_PLACES_ERROR);
            var quantity = doc.querySelector('details > quantity');
            if (!quantity || Number(quantity.textContent) !== count) throw new Error('the card count in this file does not match its cards. Export the file again from mpcfill.com and upload the new file.');
            return {profileName: 'Uploaded XML', count: count, cards: cards, twoSided: xmlTwoSidedCount(doc)};
          }

          // Two-sided cards in an XML: slots with a back of their own, by the same rule
          // as the cart (assets/trc-deck-art.js xmlDeckCards). The deck's own card
          // back and TRC's backs are not per-card backs, nor are Studio's generated
          // preview and info-card images.
          // TRC's backs: every Drive upload of the brown print back and of the white info-card
          // back (a new upload adds its id here; earlier ids stay), and Studio's default marker.
          var XML_TRC_BACK_IDS = ['19d4vZZFHNC1LMe04z7CBLmygv9U-_bJZ', '1Knmcv9YDYQE0uihaWZV0xTIshcZGfKeA',
            '1StN4IQV-Kdat2TE43JHGaD-VZoGuz6VO', '1wVxthaH2sAlD2RZkdO_uW2TUKCZWPKe-', 'trc:default-cardback'];
          function xmlDefaultBack(id, cardback) {
            return XML_TRC_BACK_IDS.indexOf(id) !== -1
              || /^local:TRC[\s_]+Card[\s_]+Back[\s_]+4\.png$/i.test(id)
              || /^local:TRC[\s_]+White[\s_]+Cardback\.png$/i.test(id)
              || (!!cardback && id === cardback);
          }
          function xmlGeneratedLocal(id, sourceType) {
            if (id.indexOf('local:') !== 0 && sourceType !== 'Local File') return false;
            var filename = id.indexOf('local:') === 0 ? id.slice(6) : id;
            if (/[\\/\r\n]/.test(filename)) return false;
            return /^.+[\s_]+Deck[\s_]+Preview(?:[\s_]+(?:Standard|Spotlight)(?:_[A-Za-z0-9]+)?)?(?: \(\d+\))?\.png$/i.test(filename)
              || /^TRC[\s_]+White[\s_]+Cardback(?: \(\d+\))?\.png$/i.test(filename);
          }
          function xmlTwoSidedCount(doc) {
            try {
              var order = doc.documentElement;
              var child = function (node, tag) {
                for (var next = node && node.firstElementChild; next; next = next.nextElementSibling) if (next.tagName === tag) return next;
                return null;
              };
              var text = function (node, tag) { var found = child(node, tag); return found ? (found.textContent || '').trim() : ''; };
              var bySlot = function (section) {
                var slots = {};
                var list = child(order, section);
                for (var card = list && list.firstElementChild; card; card = card.nextElementSibling) {
                  if (card.tagName !== 'card') continue;
                  text(card, 'slots').split(',').forEach(function (raw) {
                    if (!/^\s*\d+\s*$/.test(raw)) return;
                    var slot = String(Number(raw));
                    if (!Object.prototype.hasOwnProperty.call(slots, slot)) slots[slot] = card;
                  });
                }
                return slots;
              };
              var fronts = bySlot('fronts'), backs = bySlot('backs');
              var cardback = text(order, 'cardback');
              var studio = !!text(order, 'trcProject');
              return Object.keys(fronts).filter(function (slot) {
                var back = backs[slot];
                var backId = back ? text(back, 'id') : '';
                return !!backId && !xmlDefaultBack(backId, cardback) && !(studio && xmlGeneratedLocal(backId, text(back, 'sourceType')));
              }).length;
            } catch (ignore) {
              return 0;
            }
          }

          // File picker: read + validate locally, stage the text (no upload yet)
          if (xmlFile) {
            listen(xmlFile, 'change', function () {
              xmlCardCount = 0;
              xmlTwoSided = 0;
              if (exactQuantity) exactQuantity.setCount(0, 'xml');
              clearDeckValidation('xml');
              var f = xmlFile.files && xmlFile.files[0];
              if (!f) { xmlText = null; xmlInput.value = ''; xmlFileName.textContent = 'No file chosen'; validate(); return; }
              if (f.size > 512 * 1024) {
                xmlText = null; xmlInput.value = ''; xmlCardCount = 0;
                xmlFileName.textContent = f.name + ' is larger than the 512 KB limit.';
                validate(); return;
              }
              var reader = new FileReader();
              reader.onload = function () {
                if (lifecycle.signal.aborted || !xmlFile.files || xmlFile.files[0] !== f) return;
                var text = reader.result;
                var doc = new DOMParser().parseFromString(text, 'application/xml');
                if (doc.querySelector('parsererror')) {
                  xmlText = null; xmlInput.value = '';
                  xmlFileName.textContent = f.name + " doesn't look like a valid MPC Fill XML file.";
                } else {
                  var parsedPreview;
                  try { parsedPreview = parseUploadedXmlPreview(doc); }
                  catch (error) {
                    xmlText = null; xmlInput.value = ''; xmlFileName.textContent = f.name + ': ' + error.message; validate(); return;
                  }
                  var cardCountXml = parsedPreview.count;
                  xmlCardCount = cardCountXml;
                  xmlTwoSided = parsedPreview.twoSided;
                  if (exactQuantity) exactQuantity.setCount(cardCountXml, 'xml');

                  if (cardCountXml < MINIMUM || cardCountXml > TARGET) {
                    xmlText = null; xmlInput.value = '';
                    xmlFileName.textContent = f.name;
                  } else {
                    xmlText = text;
                    xmlFileNameValue = f.name;
                    xmlInput.value = 'ready';
                    xmlFileName.textContent = f.name;
                  }
                }
                validate();
                scheduleProfilePreview('xml');
              };
              reader.onerror = function () { if (lifecycle.signal.aborted || !xmlFile.files || xmlFile.files[0] !== f) return; xmlText = null; xmlInput.value = ''; validate(); };
              reader.readAsText(f);
            });
          }

          function syncValidationVariant() {
            var next = selectedVariantId();
            if (next !== validationVariantId) {
              validationVariantId = next;
              TARGET = currentTarget(); MINIMUM = currentMinimum();
              syncVariantDeckContents();
              ['text', 'link', 'xml', 'images'].forEach(clearDeckValidation);
              refreshSizeLabel();
              validate();
              scheduleProfilePreview(currentMode());
            }
            syncFoilPreview();
            syncCompanionPrices();
          }
          var idField = form ? form.querySelector('[name="id"]') : null;
          var companionPriceObserver;
          if (companionPanel && root.closest('product-info')) {
            companionPriceObserver = new MutationObserver(syncCompanionPrices);
            companionPriceObserver.observe(root.closest('product-info'), {childList:true, subtree:true});
          }
          var variantObserver;
          if (idField) {
            variantObserver = new MutationObserver(syncValidationVariant);
            variantObserver.observe(idField, {attributes: true, attributeFilter: ['value']});
            listen(form, 'change', syncValidationVariant);
          }

          // The theme swaps the form's variant only after fetching the new option's
          // section. Until then the form still holds the old variant, so adding to
          // cart must wait (a Standard deck must never be bought while Foil shows).
          var variantChangePendingUntil = 0;
          var variantChangeTimer = null;
          function variantChangePending() {
            return Date.now() < variantChangePendingUntil;
          }
          function settleVariantChange() {
            if (!variantChangePendingUntil) return;
            variantChangePendingUntil = 0;
            if (variantChangeTimer) window.clearTimeout(variantChangeTimer);
            variantChangeTimer = null;
            if (!lifecycle.signal.aborted) validate();
          }
          listen(document, 'change', function (event) {
            var target = event.target;
            var picker = target && target.closest ? target.closest('variant-selects') : null;
            var productInfo = root.closest('product-info');
            if (!picker || !productInfo || !productInfo.contains(picker)) return;
            // Safety valve: if the theme's request fails, fall back to today's behavior.
            variantChangePendingUntil = Date.now() + 8000;
            if (variantChangeTimer) window.clearTimeout(variantChangeTimer);
            variantChangeTimer = window.setTimeout(settleVariantChange, 8100);
            validate();
          }, true);
          listen(document, 'variant:changed', function () {
            window.setTimeout(function () {
              syncModeSelection(currentMode());
              syncValidationVariant();
              settleVariantChange();
            }, 0);
          });
          listen(window, 'pageshow', function (event) {
            syncModeSelection(currentMode());
            // Back from the back-forward cache: held tokens may have expired.
            if (!event || !event.persisted) return;
            turnstileTokenAt = customImagesTokenAt = cardbackTokenAt = 0;
            if (turnstileToken) { spentDeckTokens[turnstileToken] = 1; resetDeckValidationChallenge(); }
          });
          listen(document, 'change', function (event) {
            var target = event.target;
            if (!target || !target.matches('[name="options[Print Type]"]')) return;
            var productInfo = root.closest('product-info');
            if (productInfo && !productInfo.contains(target)) return;
            syncFoilPreview();
          }, true);

          function mountExactQuantity() {
            if (!exactRoot || exactQuantity || !window.TRCExactQuantity) return;
            exactQuantity = window.TRCExactQuantity.mount({root:exactRoot,form:form,config:exactConfig,
              useFilledButton:byId('customImagesClearEmpty'),
              onVariant:function(id){validationVariantId=id;},
              onResize:function(n){return !customDeckEditor || customDeckEditor.setLimits(1,n);},
              onUseFilled:function(){return customDeckEditor ? customDeckEditor.useFilledCount() : 0;},
              onChange:function(){
                ['text','link','xml','images'].forEach(clearDeckValidation);
                syncFoilPreview(); validate(); scheduleProfilePreview(currentMode());
              }
            });
            exactQuantity.setMode(currentMode());
            if (customDeckEditor) exactQuantity.restoreCount(customDeckEditor.plan().selectedCount);
            exactQuantity.showFilled(customImageFrontCount);
            syncFoilPreview(); validate(); scheduleProfilePreview(currentMode());
          }
          if (exactConfig) {
            listen(document,'trc-exact-quantity-ready',mountExactQuantity,{once:true});
            mountExactQuantity();
          }

          restoreStoredMode();
          radios.forEach(function (r) { listen(r, 'change', function () { setMode(currentMode()); }); });
          if (creatorCopyLink) listen(creatorCopyLink, 'click', copyCreatorDeckLink);
          if (deckLinkRefresh) listen(deckLinkRefresh, 'click', requestDeckRefresh);
          if (deckLinkRefresh) {
            updateDeckRefreshButton();
            if (Date.now() < deckRefreshCooldownUntil) {
              if (deckRefreshCooldownTimer) window.clearTimeout(deckRefreshCooldownTimer);
              deckRefreshCooldownTimer = window.setTimeout(
                updateDeckRefreshButton,
                Math.max(0, deckRefreshCooldownUntil - Date.now()) + 100
              );
            }
          }
          var textFileInput = byId('decklistTextFile');
          var textFileGeneration = 0;
          if (textFileInput) listen(textFileInput, 'change', function () {
            var generation = ++textFileGeneration;
            var file = textFileInput.files && textFileInput.files[0];
            var status = byId('decklistTextFileStatus');
            var fileName = byId('decklistTextFileName');
            if (status) status.textContent = '';
            if (fileName) { fileName.textContent = file ? file.name : ''; fileName.hidden = !file; }
            if (!file) return;
            if (file.size > F.LIST_LIMITS.maxFileBytes) { if(status) status.textContent=F.MESSAGES.fileTooLarge; return; }
            var reader = new FileReader();
            reader.onload = function () {
              if (lifecycle.signal.aborted || generation !== textFileGeneration || currentMode() !== 'text') return;
              var text = String(reader.result || '').replace(/^\uFEFF/, '');
              // D-2: an MTGO .dek (XML) becomes "N Name" lines with a Sideboard section.
              if (/\.dek$/i.test(file.name) || /^\s*<(?:\?xml|Deck)\b/i.test(text)) {
                var converted = convertDekFile(text);
                if (converted === null) { if (status) status.textContent = F.MESSAGES.fileUnreadable; return; }
                text = converted;
              }
              // Shown as it will be checked and printed (plain headers, no deck-site markers).
              textarea.value = cleanDecklistText(text);
              if (status) status.textContent = '';
              textarea.dispatchEvent(new Event('input', {bubbles:true}));
            };
            reader.onerror = function () { if(status && generation === textFileGeneration) status.textContent='Could not read this list. Try another text file.'; };
            reader.readAsText(file, 'UTF-8');
          });
          // The upload Worker refuses decklists with hidden line separators (TRC
          // Studio would split lines on them). Clean a pasted list in place: the
          // invisible NEL is dropped as on submit, the others become plain line
          // breaks, which is how they display.
          function cleanHiddenLineSeparators(value) {
            return String(value || '').replace(/\u0085/g, '').replace(/[\u000B\u000C\u001C-\u001E\u2028\u2029]/g, '\n');
          }
          listen(textarea, 'input', function () {
            var cleaned = cleanHiddenLineSeparators(textarea.value);
            if (cleaned !== textarea.value) {
              var caret = cleanHiddenLineSeparators(textarea.value.slice(0, textarea.selectionStart || 0)).length;
              textarea.value = cleaned;
              try { textarea.setSelectionRange(caret, caret); } catch (_) {}
            }
            textarea.setCustomValidity('');
            clearDeckValidation();
            validate();
            scheduleProfilePreview('text');
          });
          // Pasting the link that is already being checked changes nothing: the
          // running check (and its "Still checking" status) carries on.
          var lastLinkInput = null;
          function linkCheckInFlight() {
            var pending = profilePreviewCache[profilePreviewCacheKey('link')];
            return !!(pending && typeof pending.then === 'function');
          }
          function urlInputChanged(immediate) {
            var sameLink = urlInput.value === lastLinkInput;
            lastLinkInput = urlInput.value;
            if (sameLink && linkCheckInFlight()) return;
            clearCompanion();
            urlInput.setCustomValidity('');
            clearDeckValidation();
            if (exactQuantity) exactQuantity.setCount(0, 'link');
            validate();
            scheduleProfilePreview('link', immediate === true);
          }
          listen(urlInput, 'input', function () { linkCheckNow = false; urlInputChanged(); });
          // D-8: on leaving the field (or a paste), show the canonical link or
          // say at once that the link is not one we can read.
          function settleUrlInput(pasted) {
            if (lifecycle.signal.aborted || currentMode() !== 'link') return;
            if (canonicalizeUrlInput()) { urlInputChanged(true); return; }
            if (urlInput.value.trim() && !validDeckUrl(urlInput.value)) { updateLinkValidationStatus('error', {error: F.MESSAGES.unsupportedLink}); return; }
            // A pasted link is complete: check it now instead of after the typing pause.
            if (pasted === true && profilePreviewTimer && !linkCheckInFlight()) scheduleProfilePreview('link', true);
          }
          listen(urlInput, 'blur', function () { settleUrlInput(); });
          listen(urlInput, 'paste', function () { window.setTimeout(function () { settleUrlInput(true); }, 0); });
          if (sideboardCheck) listen(sideboardCheck, 'change', function () { clearDeckValidation(); validate(); scheduleProfilePreview('link'); });
          if (customImagesClear) listen(customImagesClear, 'click', function () {
            askToConfirm(customImagesClear.parentNode, 'Clear this deck? This will remove all uploaded images, slot assignments, and saved work.', 'Clear deck', true).then(function (confirmed) {
            if (!confirmed || lifecycle.signal.aborted) return;
            if (customDeckEditor) {
              customImagesUploadError = '';
              customImagesManifest.value = '';
              customDeckEditor.clear();
            } else {
              customImagesInput.value = '';
              customImageFiles = [];
              customImageLibraryCount = 0;
              customImageHasDraft = false;
              customImagesError = '';
              customImagesUploadError = '';
              customImagesManifest.value = '';
              renderCustomImages();
              validate();
            }
            });
          });
          artRadios.forEach(function (r) {
            listen(r, 'change', function () {
              artSelectionTouched = true;
              var mode = r.getAttribute('data-art') || currentMode();
              var cacheKey = profilePreviewCacheKey(mode);
              if (deckValidationResult[mode] && deckValidationResultKey[mode] === cacheKey) {
                showSelectedProfilePreview(mode, deckValidationResult[mode]);
              } else {
                scheduleProfilePreview(mode);
              }
              validate();
            });
          });
          cardbackFileInputs.forEach(function (inp) {
            listen(inp, 'change', function () {
              var suffix = inp.getAttribute('data-cardback-file');
              stageCardback(suffix, (inp.files && inp.files[0]) || null);
            });
          });
          root.querySelectorAll('[data-cardback-remove]').forEach(function (btn) {
            listen(btn, 'click', function () {
              var suffix = btn.getAttribute('data-cardback-remove');
              var inp = cbEl('cardback-file', suffix);
              if (inp) inp.value = '';
              stageCardback(suffix, null);
            });
          });

          if (window.TRCDeckLinks) {
            incomingDeckLink = window.TRCDeckLinks.setup(root, PRODUCT_URL, IS_CUSTOM_DECK && !IS_CREATOR_DECK, validDeckUrl, {
              input: urlInput, sideboard: sideboardCheck, setMode: syncModeSelection, mode: currentMode, signal: lifecycle.signal,
              textarea: textarea, config: deckInputConfig
            });
            if (incomingDeckLink) linkCheckNow = true;
          }
          // The selected print option decides the board, even for a shared link.
          syncVariantDeckContents();
          setMode(currentMode());
          syncFoilPreview();
          ensureTurnstileWidgets();
          // Let the global upload center re-verify a failed image job from this
          // page (its original single-use token was spent).
          var releaseUploadTokenProvider = null;
          if (customImagesVerify && window.TRCBackgroundUploads && typeof window.TRCBackgroundUploads.setTokenProvider === 'function') {
            releaseUploadTokenProvider = window.TRCBackgroundUploads.setTokenProvider(function () {
              if (lifecycle.signal.aborted) return Promise.reject(new Error('Open the custom deck page to verify this upload again.'));
              return waitForCustomImagesToken().then(consumeCustomImagesToken);
            });
          }

          if (submitBtn) {
            listen(submitBtn, 'click', function (event) {
              if (submitBtn.disabled || validate()) return;
              event.preventDefault();
              requirementsRevealed = true;
              validate();
            });
          }

          // Submit handler: block if invalid; for XML mode, upload first then re-submit
          var uploading = false;
          var incompleteDeckConfirmed = false;

          function backgroundUploadProperties() {
            var properties = {};
            if (!form) return properties;
            new FormData(form).forEach(function (value, key) {
              var match = /^properties\[(.+)\]$/.exec(key);
              if (!match || typeof value !== 'string' || !value) return;
              properties[match[1]] = value;
            });
            delete properties['_Custom images'];
            delete properties['_Deck validation'];
            delete properties['Card back'];
            properties['_Input method'] = 'Custom image upload';
            return properties;
          }

          var storageTimer = null;
          // Set once this browser refused to keep images (private mode, blocked or
          // full storage, or no answer): later decks on this page upload from the
          // page at once instead of waiting on storage again.
          var uploadStorageRefused = false;
          function queueCustomImageUpload(token) {
            if (!window.TRCBackgroundUploads || typeof window.TRCBackgroundUploads.enqueue !== 'function') {
              return Promise.reject(Object.assign(new Error('Background uploads are not available. Refresh the page and try again.'), {code: 'UPLOAD_STORAGE_UNAVAILABLE'}));
            }
            var quantityInput = form.querySelector('[name="quantity"]');
            var sellingPlanInput = form.querySelector('[name="selling_plan"]');
            var stagedCardback = cardback.images ? cardback.images.file : null;
            // The token is spent once the Worker sees it; never offer it again.
            consumeCustomImagesToken(token);
            // Browser storage that never answers (seen in Safari Private Browsing)
            // must not hold the upload: after 20 s (plus time for very large
            // decks) give up and upload from the page. A late store is dropped.
            var abandoned = false;
            var bytes = customImageFiles.reduce(function (sum, file) { return sum + Number(file.size || 0); }, 0);
            var limit = 20000 + Math.ceil(bytes / 10000000) * 1000;
            var timedOut = new Promise(function (_, reject) {
              storageTimer = window.setTimeout(function () {
                abandoned = true;
                reject(Object.assign(new Error('Browser storage did not respond.'), {code: 'UPLOAD_STORAGE_TIMEOUT'}));
              }, limit);
            });
            var queued = window.TRCBackgroundUploads.enqueue({
              isAbandoned: function () { return abandoned; },
              workerUrl: WORKER_URL,
              adminDeck: adminDeck ? adminDeck.connection : null,
              turnstileToken: token,
              variantId: selectedVariantId(),
              quantity: quantityInput ? Number(quantityInput.value || 1) : 1,
              sellingPlan: sellingPlanInput ? sellingPlanInput.value : '',
              productTitle: PRODUCT_TITLE,
              productUrl: PRODUCT_URL,
              properties: backgroundUploadProperties(),
              files: customImageFiles.slice(),
              slots: customImageSlots.slice(),
              slotCount: customImageFrontCount,
              cardback: stagedCardback,
            });
            return Promise.race([queued, timedOut]).then(function (job) { window.clearTimeout(storageTimer); return job; },
              function (error) { window.clearTimeout(storageTimer); throw error; });
          }

          // Keep the deck in the editor until the Worker has accepted the upload
          // session. If the start fails, drop the stored job (its token is spent)
          // so the customer can simply press Add to cart again.
          function startQueuedCustomImageUpload(job) {
            var manager = window.TRCBackgroundUploads;
            if (!job || !job.id || !manager || typeof manager.start !== 'function') return Promise.resolve(job);
            return manager.start(job.id).catch(function (error) {
              if (!error || !error.needsVerification || error.sessionExpired || error.status !== 401 || !retrySecurity(error) || typeof manager.retry !== 'function') throw error;
              return securityRetryWait(error).then(function () { return manager.retry(job.id); }).then(function () { return manager.start(job.id); });
            }).catch(function (error) {
              var shown = new Error(error && error.needsVerification
                ? 'The upload security check did not go through. Press Add to cart to try again. Your images are still in the editor.'
                : ((error && error.message) || 'Could not start the upload.') + ' Your images are still in the editor.');
              var dismissed = typeof manager.dismiss === 'function' ? Promise.resolve(manager.dismiss(job.id)).catch(function () {}) : Promise.resolve();
              return dismissed.then(function () { throw shown; });
            });
          }

          function resetImageDeckAfterQueue() {
            customImagesUploadError = '';
            customImagesManifest.value = '';
            setDeckValidation('images', '');
            incompleteDeckConfirmed = false;
            stageCardback('images', null);
            if (customDeckEditor) customDeckEditor.clear();
            else {
              customImagesInput.value = '';
              customImageFiles = [];
              customImageSlots = [];
              customImageFrontCount = 0;
              customImageHasDraft = false;
              renderCustomImages();
            }
          }

          // Ask inline after Add to cart, then submit again with the answer recorded.
          // A second press while the question is open keeps the one question.
          var submitConfirmOpen = false;
          var submitConfirm = null;
          function confirmThenSubmit(message, stillCurrent, accept) {
            if (submitConfirmOpen) return;
            submitConfirmOpen = true;
            // The question closes by itself once its deck or tab changes (validate()).
            var controller = typeof AbortController === 'function' ? new AbortController() : null;
            submitConfirm = {stillCurrent: stillCurrent, controller: controller};
            askToConfirm(submitRequirements || submitBtn, message, 'Add to cart', false, controller && controller.signal).then(function (confirmed) {
              submitConfirmOpen = false;
              submitConfirm = null;
              if (!confirmed || lifecycle.signal.aborted || !stillCurrent()) return;
              accept();
              form.requestSubmit(submitBtn);
            }, function () { submitConfirmOpen = false; submitConfirm = null; });
          }

          if (form) {
            listen(form, 'submit', function (e) {
              if (cartAddInFlight()) {
                // A double tap while this deck is already being added to the cart.
                e.preventDefault(); e.stopImmediatePropagation();
                return;
              }
              // Invisible U+FEFF / U+0085 characters are trimmed differently by the
              // Worker (JavaScript) and the checkout Function (Rust), so a list that
              // validates could still be refused at checkout. Drop them on submit;
              // if that changes the list, the proof no longer matches and the
              // normal validation step below re-checks it.
              if (currentMode() === 'text' && /[\uFEFF\u0085]/.test(textarea.value)) {
                textarea.value = textarea.value.replace(/[\uFEFF\u0085]/g, '');
              }
              if (adminDeck && (adminDeck.pending || adminDeck.error || adminDeck.sent)) {
                e.preventDefault(); e.stopImmediatePropagation();
                adminDeck.report(adminDeck.error || (adminDeck.sent ? 'Return to TRC Studio to save this deck.' : 'Please wait for the saved deck to finish restoring.'));
                return;
              }
              var submittingMode = currentMode();
              if (profilePreviewResult[submittingMode]) {
                applyProfilePreviewFields(submittingMode, profilePreviewResult[submittingMode]);
              }
              if (!validate()) {
                hideSubmitProgress();
                e.preventDefault();
                e.stopImmediatePropagation();
                requirementsRevealed = true;
                validate();
                if (currentMode() === 'images' && customImageFrontCount < 1 && customDeckEditor) {
                  customDeckEditor.open();
                }
                return;
              }

              var mode = submittingMode;
              if (mode === 'images' && canClearEmptySlots()) {
                e.preventDefault(); e.stopImmediatePropagation();
                if (emptySlotsDialogOpen) return;
                emptySlotsDialogOpen = true;
                // If the dialog cannot open, never leave Add to cart dead.
                var emptySlotsChoice;
                try { emptySlotsChoice = Promise.resolve(exactQuantity.confirmEmptySlots()); }
                catch (error) { emptySlotsChoice = Promise.reject(error); }
                emptySlotsChoice.catch(function (error) {
                  window.setTimeout(function () { throw error; });
                  return 'dismiss';
                }).then(function(action) {
                  emptySlotsDialogOpen = false;
                  if (lifecycle.signal.aborted || currentMode() !== 'images') return;
                  if (action === 'edit') { customDeckEditor.open(); return; }
                  if (action !== 'confirm') return;
                  if (!canClearEmptySlots()) { validate(); return; }
                  var filled = customDeckEditor.useFilledCount();
                  if (!filled) { validate(); return; }
                  exactQuantity.restoreCount(filled);
                  requirementsRevealed = false;
                  if (validate()) form.requestSubmit(submitBtn);
                }).catch(function () { emptySlotsDialogOpen = false; });
                return;
              }
              if (!exactConfig && mode === 'images' && customImageFrontCount < TARGET && !incompleteDeckConfirmed) {
                var missingSlots = TARGET - customImageFrontCount;
                e.preventDefault();
                e.stopImmediatePropagation();
                confirmThenSubmit(
                  'This deck has ' + customImageFrontCount + ' filled slot' + (customImageFrontCount === 1 ? '' : 's') +
                  ' and ' + missingSlots + ' empty slot' + (missingSlots === 1 ? '' : 's') +
                  '. Add it to your cart anyway?',
                  (function (count) { return function () { return currentMode() === 'images' && customImageFrontCount === count; }; })(customImageFrontCount),
                  function () { incompleteDeckConfirmed = true; }
                );
                return;
              }

              // Text and URL decks are normalized and counted by the upload
              // service before Shopify receives the line item. The signed
              // proof is rechecked server-side by the checkout Function.
              if ((mode === 'text' || mode === 'link') && !deckValidationField.value && !uploading) {
                e.preventDefault();
                e.stopImmediatePropagation();
                uploading = true;
                if (submitBtn) submitBtn.disabled = true;
                var isMoxfield = mode === 'link' && /^https:\/\/(?:www\.)?moxfield\.com\/decks\//i.test(urlInput.value.trim());
                showSubmitProgress(mode === 'text'
                  ? 'Checking decklist…'
                  : (isMoxfield ? 'Waiting for Moxfield…' : 'Checking deck link…'));
                var submittedKey = profilePreviewCacheKey(mode);
                requestDeckValidation(mode).then(function (result) {
                  if (currentMode() !== mode || !applyDeckValidationResult(mode, result, submittedKey)) throw new Error('Deck or print option changed. Please submit the current deck again.');
                  uploading = false;
                  validate();
                  finishSubmitProgress();
                  form.requestSubmit(submitBtn);
                }).catch(function (err) {
                  uploading = false;
                  hideSubmitProgress();
                  if (submitBtn) submitBtn.disabled = false;
                  validate();
                  // Refresh or the status watchdog started the check over: no native
                  // error bubble; the deck status beside the field shows the new check.
                  if (err && err.cancelled) return;
                  if (mode === 'text' && currentMode() === mode && submittedKey === profilePreviewCacheKey(mode)) {
                    recordDeckError(mode, err, submittedKey);
                    textarea.reportValidity();
                  } else if (mode === 'text') {
                    // The list or print option changed while it was being checked:
                    // say so instead of silently doing nothing.
                    showSubmitNotice('Your deck changed while it was being checked. Review it, then press Add to cart again.');
                  }
                  if (mode === 'link') {
                    urlInput.setCustomValidity(err.message || 'Deck validation failed');
                    urlInput.reportValidity();
                  }
                });
                return;
              }

              // A shorter deck than a fixed-size option prints: say so and let the
              // shopper decide (the counts are known here: text and link decks were
              // just validated, an XML file was counted when it was chosen).
              if ((mode === 'text' || mode === 'link' || mode === 'xml') && !underCountConfirmed && !uploading) {
                var shortBy = underCountMessage(validatedCount(mode));
                if (shortBy) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  var shortKey = profilePreviewCacheKey(mode);
                  confirmThenSubmit(shortBy + ' Add it to your cart anyway?', function () {
                    return currentMode() === mode && profilePreviewCacheKey(mode) === shortKey;
                  }, function () { underCountConfirmed = true; });
                  return;
                }
              }

              // XML tab: upload the staged XML, then re-submit with the resulting URL.
              if (mode === 'xml' && xmlInput.value === 'ready' && !uploading) {
                e.preventDefault();
                e.stopImmediatePropagation();
                uploading = true;
                if (submitBtn) submitBtn.disabled = true;
                xmlFileName.textContent = 'Uploading…';
                showSubmitProgress('Uploading deck file…');
                var submittedXmlKey = profilePreviewCacheKey('xml');
                uploadDecklist(xmlText).then(function (result) {
                  if (lifecycle.signal.aborted || currentMode() !== 'xml' || submittedXmlKey !== profilePreviewCacheKey('xml')) throw new Error('Deck or print option changed. Please submit again.');
                  // Store "filename|url" so the cart can show the real name; Liquid splits on "|"
                  var safeName = (xmlFileNameValue || 'decklist.xml').replace(/\|/g, '-');
                  xmlInput.value = safeName + '|' + result.url;
                  xmlCardCount = Number(result.count || xmlCardCount);
                  if (exactQuantity) exactQuantity.adopt(result.quote);
                  setDeckValidation('xml', result.validationToken || '');
                  uploading = false;
                  validate();
                  finishSubmitProgress();
                  form.requestSubmit(submitBtn);
                }).catch(function (err) {
                  uploading = false;
                  hideSubmitProgress();
                  if (submitBtn) submitBtn.disabled = false;
                  xmlFileName.textContent = withRetryHint(err.message);
                  resetDeckValidationChallenge();
                  validate();
                });
                return;
              }

              // Custom Images tab: persist a standalone job and its File blobs
              // before returning control to the shopper. The global upload
              // manager resumes it across normal site navigation, adds the
              // completed deck to cart, and keeps same-product jobs separate.
              if (mode === 'images' && !/\|https?:\/\//.test(customImagesManifest.value) && !uploading) {
                e.preventDefault();
                e.stopImmediatePropagation();
                customImagesUploadError = '';
                uploading = true;
                if (submitBtn) submitBtn.disabled = true;
                showSubmitProgress('Preparing secure upload…');
                (uploadStorageRefused
                  ? Promise.reject(Object.assign(new Error('Browser storage refused this upload before.'), {code: 'UPLOAD_STORAGE_REFUSED'}))
                  : waitForCustomImagesToken().then(queueCustomImageUpload)
                ).catch(function (error) {
                  // This browser cannot keep the images for a background upload
                  // (private mode, storage blocked or full): upload them from this
                  // page instead, then add the deck to the cart as usual.
                  // Unreadable files (not downloaded from iCloud, moved) fail here too: say so.
                  var code = String(error && error.code || '');
                  if (lifecycle.signal.aborted || !/^UPLOAD_STORAGE_/.test(code) || code === 'UPLOAD_STORAGE_NotReadableError') throw error;
                  uploadStorageRefused = true;
                  return waitForCustomImagesToken().then(function () { return uploadCustomImages(true); }).then(function () {
                    uploading = false;
                    validate();
                    finishSubmitProgress();
                    form.requestSubmit(submitBtn);
                    return null;
                  });
                }).then(function (job) {
                  if (job === null) return null;
                  return startQueuedCustomImageUpload(job).then(function () { return job; });
                }).then(function (job) {
                  if (job === null) return;
                  resetImageDeckAfterQueue();
                  if (adminDeck) { adminDeck.sent = true; adminDeck.report('Upload started. Wait for completion, then check the deck in TRC Studio.'); }
                  uploading = false;
                  validate();
                  showSubmitProgress(adminDeck ? 'Upload started. Wait until the deck is ready in TRC Studio.' : 'Upload started. You can keep shopping.', 0);
                  window.setTimeout(hideSubmitProgress, 2500);
                }).catch(function (error) {
                  uploading = false;
                  hideSubmitProgress();
                  if (submitBtn) submitBtn.disabled = false;
                  if (!customImagesUploadError) {
                    customImagesUploadError = error && error.message ? error.message : 'Could not start the upload. Check your connection and browser privacy settings, then try Add to cart again. Your images are still in the editor.';
                  }
                  requirementsRevealed = true;
                  renderCustomImages();
                  validate();
                });
                return;
              }

              // Text / Link tabs: if a card back is staged (optional), upload it first,
              // write "filename|url" into the visible "Card back" property, then re-submit.
              if ((mode === 'text' || mode === 'link' || mode === 'images') && cardbackState(mode) === 'staged' && !uploading) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var data = cardback[mode];
                var nameEl = cbEl('cardback-name', mode);
                var prevName = nameEl ? nameEl.textContent : '';
                uploading = true;
                if (submitBtn) submitBtn.disabled = true;
                if (nameEl) nameEl.textContent = 'Uploading…';
                showSubmitProgress('Uploading card back…');
                var submittedBackKey = profilePreviewCacheKey(mode);
                var submittedBackProof = deckValidationField.value;
                sendCardback(data.file, submittedBackProof).then(function (result) {
                  if (lifecycle.signal.aborted || currentMode() !== mode || submittedBackKey !== profilePreviewCacheKey(mode) || submittedBackProof !== deckValidationField.value || cardback[mode] !== data) throw new Error('Deck or card back changed. Please submit again.');
                  var field = cbEl('cardback-field', mode);
                  var safeName = (data.name || 'card-back.png').replace(/\|/g, '-');
                  if (field) { field.disabled = false; field.value = safeName + '|' + result.url; }
                  setDeckValidation(mode, result.validationToken || '');
                  if (nameEl) nameEl.textContent = prevName;
                  teardownCardbackTurnstile(); // token is single-use; widget no longer needed
                  uploading = false;
                  validate();
                  finishSubmitProgress();
                  form.requestSubmit(submitBtn);
                }).catch(function (err) {
                  uploading = false;
                  hideSubmitProgress();
                  if (nameEl) nameEl.textContent = prevName;
                  var msgEl = cbEl('cardback-msg', mode);
                  if (msgEl) {
                    msgEl.hidden = false; msgEl.classList.add('is-error');
                    msgEl.textContent = withRetryHint(err.message);
                  }
                  // Refresh Turnstile so they can retry with a fresh token
                  if (window.turnstile && cardbackWidgetId !== null) {
                    try { window.turnstile.reset(cardbackWidgetId); } catch (e2) {}
                  }
                  cardbackToken = null;
                  if (submitBtn) submitBtn.disabled = false;
                  validate();
                });
                return;
              }

              if (mode !== 'images' && !deckValidationField.value) {
                e.preventDefault();
                e.stopImmediatePropagation();
                clearDeckValidation();
                validate();
                return;
              }
              if (mode === 'images' && incompleteDeckConfirmed) {
                window.setTimeout(function () { incompleteDeckConfirmed = false; }, 0);
              }
              if (underCountConfirmed) window.setTimeout(function () { underCountConfirmed = false; }, 0);
              if (adminDeck) {
                e.preventDefault(); e.stopImmediatePropagation();
                var fields = new FormData(form);
                var properties = {};
                fields.forEach(function(value, key) { var match = /^properties\[(.+)\]$/.exec(key); if (match && typeof value === 'string' && value) properties[match[1]] = value; });
                uploading = true; adminDeck.pending = false;
                if (submitBtn) submitBtn.disabled = true;
                adminDeck.send({id:String(fields.get('id')),quantity:Number(fields.get('quantity') || 1),properties:properties})
                  .catch(function(error) { adminDeck.report(error.message); })
                  .finally(function() { uploading = false; if (submitBtn) submitBtn.disabled = false; hideSubmitProgress(); });
                return;
              }
              finishSubmitProgress();
              window.setTimeout(function () {
                if (!uploading) hideSubmitProgress();
              }, 8000);
            }, true);
          }
          var adminDeck = window.TRCAdminDecks && window.TRCAdminDecks.connect({
            form: form, root: root, submit: submitBtn,
            restore: async function(initial) {
              var props = initial.properties || {};
              var quantity = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + form.id + '"]');
              if (quantity) { quantity.value = initial.quantity; quantity.dispatchEvent(new Event('change', {bubbles:true})); }
              var mode = props.Companion && props['Decklist URL'] ? 'link' : props['_Input method'] === 'Text input' && props.Decklist ? 'text' : props['_Custom images'] || props['Custom images'] ? 'images' : props['MPC Fill XML'] ? 'xml' : props['Decklist URL'] ? 'link' : props.Decklist ? 'text' : currentMode();
              syncModeSelection(mode); setMode(mode);
              if (mode === 'text' && props.Decklist) { textarea.value = props.Decklist; textarea.dispatchEvent(new Event('input',{bubbles:true})); }
              if (mode === 'link' && props['Decklist URL']) {
                if (!IS_CREATOR_DECK) urlInput.value = props['Decklist URL'];
                if (sideboardCheck) sideboardCheck.value = props['Deck contents'] || 'Mainboard';
                urlInput.dispatchEvent(new Event('input',{bubbles:true}));
                // New carts say "<name> (included)"; older carts and draft orders say "<name> — included" (an interim "<name>: included" never shipped).
                companionIncluded = /(?: \(included\)|(?:—|:) included)$/.test(props.Companion || '');
              }
              artRadios.forEach(function(radio) { if (radio.getAttribute('data-art') === mode && radio.value === props['Art style']) { radio.checked=true; radio.dispatchEvent(new Event('change',{bubbles:true})); } });
              if (mode === 'xml' && props['MPC Fill XML']) {
                var xmlBlob = await window.TRCAdminDecks.asset(props['MPC Fill XML'],512 * 1024);
                xmlText = await xmlBlob.text();
                var xmlDoc = new DOMParser().parseFromString(xmlText,'application/xml');
                if (xmlDoc.querySelector('parsererror')) throw new Error('The saved XML is invalid.');
                var parsed = parseUploadedXmlPreview(xmlDoc); xmlCardCount=parsed.count; xmlTwoSided=parsed.twoSided;
                xmlFileNameValue=props['MPC Fill XML'].split('|')[0]; xmlFileName.textContent=xmlFileNameValue; xmlInput.value='ready';
                if (exactQuantity) exactQuantity.setCount(xmlCardCount,'xml');
                scheduleProfilePreview('xml');
              }
              if (mode === 'images' && (props['_Custom images'] || props['Custom images'])) {
                var manifestBlob = await window.TRCAdminDecks.asset(props['_Custom images'] || props['Custom images'],2 * 1024 * 1024);
                var manifest = JSON.parse(await manifestBlob.text());
                if (['trc.custom-images.v1','trc.custom-images.v2'].indexOf(manifest.schema)<0 || !Array.isArray(manifest.files) || manifest.files.length>2000) throw new Error('Unsupported saved image deck.');
                var files = [];
                for (var index=0; index<manifest.files.length; index++) {
                  var savedFile=manifest.files[index];
                  files.push(await window.TRCAdminDecks.file((savedFile.name || 'card-' + index + '.png') + '|' + savedFile.url,50 * 1024 * 1024,'card.png'));
                }
                mountCustomDeckEditor();
                if (!customDeckEditor) throw new Error('The image editor could not load. Refresh this page.');
                await customDeckEditor.restoreFiles(files,manifest.slots || files.map(function(_,i){return {frontFileIndex:i,backFileIndex:null};}));
              }
              if (props['Card back'] && ['text','link','images'].indexOf(mode)>=0) {
                stageCardback(mode,await window.TRCAdminDecks.file(props['Card back'],25 * 1024 * 1024,'card-back.png'));
              }
              clearDeckValidation(); validate();
            }
          });
          function disposeDeckInput() {
            if (exactQuantity) exactQuantity.destroy();
            if (lifecycle.signal.aborted) return;
            lifecycle.abort();
            clearLinkCheckWatchdog();
            cancelDeckRequests('Product closed.');
            cancelProfileImagePreloads();
            keptProfileGrids = {};
            lifecycleListeners.splice(0).forEach(function (entry) { entry[0].removeEventListener(entry[1], entry[2], entry[3]); });
            if (releaseUploadTokenProvider) releaseUploadTokenProvider();
            if (stickyShadowFrame !== null) window.cancelAnimationFrame(stickyShadowFrame);
            root.querySelectorAll('[data-profile-preview]').forEach(clearProfilePreviewDisclosure);
            if (customImagesTokenReject) customImagesTokenReject(new Error('Product closed.'));
            customImagesTokenPromise = null;
            customImagesTokenResolve = null;
            customImagesTokenReject = null;
            Object.keys(profilePreviewRecovery).forEach(function (key) {
              var recovery = profilePreviewRecovery[key];
              [recovery.timer, recovery.printingsTimer, recovery.printingsWake].forEach(function (timer) { if (timer) window.clearTimeout(timer); });
            });
            [profilePreviewTimer, turnstileInitTimer, deckRefreshCooldownTimer, customImagesTokenTimer, variantChangeTimer, storageTimer].forEach(function (timer) { if (timer) window.clearTimeout(timer); });
            if (variantObserver) variantObserver.disconnect();
            if (companionPriceObserver) companionPriceObserver.disconnect();
            if (removalObserver) removalObserver.disconnect();
            if (window.turnstile) [deckValidationWidgetId, customImagesWidgetId, cardbackWidgetId].forEach(function (id) {
              if (id !== null) { try { window.turnstile.remove(id); } catch (_) {} }
            });
          }
          var removalObserver = new MutationObserver(function () { if (!root.isConnected) disposeDeckInput(); });
          removalObserver.observe(document.body, {childList: true, subtree: true});
          listen(document, 'shopify:section:unload', function (event) { if (event.target && event.target.contains(root)) disposeDeckInput(); });
          }
  // A product whose init throws (bad config, unexpected markup) would keep its form locked with no word why:
  // report the error (rethrown on its own, so it reaches the console and window error handlers without stopping
  // the other products) and show the snippet watchdog's message in that product's notice only. The attribute
  // tells the watchdog not to take the message back once TRCDeckInput is defined, and the form's own
  // requirements messages (listeners an init that threw part way already wired) not to replace it.
  var DECK_INPUT_MISSING_COPY = 'Something didn\u2019t load. Please refresh the page.';
  function deckInputNotice(ownerScript) {
    try {
      var scope = ownerScript.closest('product-info') || ownerScript.closest('.product-form');
      return scope && scope.querySelector('[id="trcSubmitRequirements"]');
    } catch (_) {
      return null;
    }
  }
  function deckInputInitFailed(ownerScript, error) {
    window.setTimeout(function () { throw error; });
    var notice = deckInputNotice(ownerScript);
    if (!notice) return;
    notice.setAttribute('data-trc-init-failed', '');
    notice.textContent = DECK_INPUT_MISSING_COPY;
    notice.hidden = false;
  }
  // Page HTML cached before trc-deck-feedback.js had its own tag (see the note at the top): load
  // it from next to this file, then initialize. A failed or stalled (15 s) load reports like any failed init.
  var feedbackWaiters = null;
  function whenFeedback(run) {
    F = F || window.TRCDeckFeedback || null;
    if (F) { run(); return; }
    if (feedbackWaiters) { feedbackWaiters.push(run); return; }
    feedbackWaiters = [run];
    var stall = window.setTimeout(settle, 15000);
    function settle() {
      window.clearTimeout(stall);
      var waiting = feedbackWaiters || [];
      feedbackWaiters = null;
      F = window.TRCDeckFeedback || null;
      waiting.forEach(function (next) { next(); });
    }
    try {
      var own = OWN_SCRIPT_SRC || (document.querySelector('script[src*="/trc-deck-input.js"]') || {}).src || '';
      var src = own.replace('/trc-deck-input.js', '/trc-deck-feedback.js');
      if (src === own) throw new Error('No asset path');
      var tag = document.createElement('script');
      tag.src = src;
      tag.onload = tag.onerror = settle;
      (document.head || document.documentElement).appendChild(tag);
    } catch (_) {
      window.setTimeout(settle, 0);
    }
  }
  if (!window.TRCDeckInput) window.TRCDeckInput = {
    // The page's own readers, for the parity tests (tests/deck-validation.test.mjs).
    cleanDecklistText: cleanDecklistText,
    convertDekFile: convertDekFile,
    canonicalDeckUrl: canonicalDeckUrl,
    variantDeckContents: variantDeckContents,
    get DECKLIST_SECTION_HEADER() { return (F || window.TRCDeckFeedback || {}).DECKLIST_SECTION_HEADER; },
    init: function (ownerScript, deckInputConfig) {
      whenFeedback(function () {
        try {
          if (!F) throw new Error('assets/trc-deck-feedback.js did not load.');
          initDeckInput(ownerScript, deckInputConfig);
        } catch (error) {
          deckInputInitFailed(ownerScript, error);
          return;
        }
        // Initialized: take back a watchdog message still showing (its own file may never have fired load).
        var notice = deckInputNotice(ownerScript);
        if (notice && !notice.hasAttribute('data-trc-init-failed') && notice.textContent === DECK_INPUT_MISSING_COPY) {
          notice.textContent = '';
          notice.hidden = true;
        }
      });
    }
  };
  var queue = window.TRCDeckInputQueue || [];
  window.TRCDeckInputQueue = [];
  queue.forEach(function (entry) {
    try {
      window.TRCDeckInput.init(entry[0], entry[1]);
    } catch (error) {
      deckInputInitFailed(entry[0], error); // an older copy's init, defined first, without the catch above
    }
  });
})();
